/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable unicorn/prefer-module */
/* eslint-disable unicorn/consistent-destructuring */
/* eslint-disable indent */
/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Loader } from "..";
import { useForm } from "react-hook-form";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, FormGroup, Label, Input } from "reactstrap";
import { useAuthContext } from "../../context/auth";
import adigitalLogo from "../../img/adigital-logo.png";
import screenmediaLogo from "../../img/screenmedia-logo.png";
import visionaLogo from "../../img/visiona-logo.png";
import wecastLogo from "../../img/wecast-logo.png";
import { getEdificios, saveOportunidad, getClientes, updateOportunidad, updateCliente } from "../../utils";
import PdfCotizacion from "../PdfCotizacion";
import { PDFDownloadLink, pdf } from "@react-pdf/renderer";
import "./stylesCotizadorProgrammaticCalculadora.scss";

export const CotizadorProgrammaticCalculadora = ({
  inventarioData,
  plazo,
  frecuencia,
  horasSeleccionadas = { horas: 0, intervalos: [], options: [] },
  duracion = 0, // Default value for duracion
  isProgrammaticSelected,
  onIncludeInstallingBuildingsChange,
  cotizacionCode,
  isEditMode = false,
  cliente = "",
  opportunityId,
  opportunityData,
}) => {
  const [edificios, setEdificios] = useState([]);
  const [ascensoresTotal, setAscensoresTotal] = useState(0);
  const [totemsTotal, setTotemsTotal] = useState(0);
  const [coworkTotal, setCoworkTotal] = useState(0);
  const [esperaTotal, setEsperaTotal] = useState(0);
  const [edificiosSeleccionadosAscensores, setEdificiosSeleccionadosAscensores] = useState(0);
  const [edificiosSeleccionadosTotems, setEdificiosSeleccionadosTotems] = useState(0);
  const [edificiosSeleccionadosCowork, setEdificiosSeleccionadosCowork] = useState(0);
  const [edificiosSeleccionadosEspera, setEdificiosSeleccionadosEspera] = useState(0);
  const [edificiosUnicosTotal, setEdificiosUnicosTotal] = useState(0);
  const [ascensoresSeleccionados, setAscensoresSeleccionados] = useState(0);
  const [totemsSeleccionados, setTotemsSeleccionados] = useState(0);
  const [coworkSeleccionados, setCoworkSeleccionados] = useState(0);
  const [esperaSeleccionados, setEsperaSeleccionados] = useState(0);
  const [audienciaSeleccionadaAscensor, setAudienciaSeleccionadaAscensor] = useState(0);
  const [audienciaSeleccionadaTotems, setAudienciaSeleccionadaTotems] = useState(0);
  const [audienciaSeleccionadaCowork, setAudienciaSeleccionadaCowork] = useState(0);
  const [audienciaSeleccionadaEspera, setAudienciaSeleccionadaEspera] = useState(0);
  const [audienciaSeleccionadaTotal, setAudienciaSeleccionadaTotal] = useState(0);
  const [nombresEdificiosSeleccionadosAscensores, setNombresEdificiosSeleccionadosAscensores] = useState([]);
  const [nombresEdificiosSeleccionadosTotems, setNombresEdificiosSeleccionadosTotems] = useState([]);
  const [nombresEdificiosSeleccionadosCowork, setNombresEdificiosSeleccionadosCowork] = useState([]);
  const [nombresEdificiosSeleccionadosEspera, setNombresEdificiosSeleccionadosEspera] = useState([]);
  const [nombresEdificiosNoSeleccionados, setNombresEdificiosNoSeleccionados] = useState([]);
  const [showLinkModal, setShowLinkModal] = useState(false);
  const [clientes, setClientes] = useState([]);
  const [clienteParaDescarga, setClienteParaDescarga] = useState(null);
  const [hasInstallingBuildings, setHasInstallingBuildings] = useState(false);
  const [includeInstallingBuildings, setIncludeInstallingBuildings] = useState(false);
  const [loading, setLoading] = useState(false);
  const [initialData, setInitialData] = useState(null);
  const [hasChanges, setHasChanges] = useState(false);
  const [horasFinal, setHorasFinal] = useState(0);
  const [salidasAscensores, setSalidasAscensores] = useState(0);
  const [salidasTotems, setSalidasTotems] = useState(0);
  const [salidasCowork, setSalidasCowork] = useState(0);
  const [salidasEspera, setSalidasEspera] = useState(0);
  const [salidasTotales, setSalidasTotales] = useState(0);
  const [impactosTotalAscensores, setImpactosTotalAscensores] = useState(0);
  const [impactosTotalTotems, setImpactosTotalTotems] = useState(0);
  const [impactosTotalCowork, setImpactosTotalCowork] = useState(0);
  const [impactosTotalEspera, setImpactosTotalEspera] = useState(0);
  const [impactosTotales, setImpactosTotales] = useState(0);
  const [inversionAscensoresFinal, setInversionAscensoresFinal] = useState(0);
  const [inversionTotemsFinal, setInversionTotemsFinal] = useState(0);
  const [inversionCoworkFinal, setInversionCoworkFinal] = useState(0);
  const [inversionEsperaFinal, setInversionEsperaFinal] = useState(0);
  const [inversionFinalTotal, setInversionFinalTotal] = useState(0);
  const [tarifaFriaAscensores, setTarifaFriaAscensores] = useState(0);
  const [tarifaFriaTotems, setTarifaFriaTotems] = useState(0);
  const [tarifaFriaCowork, setTarifaFriaCowork] = useState(0);
  const [tarifaFriaEspera, setTarifaFriaEspera] = useState(0);
  const [tarifaFriaTotal, setTarifaFriaTotal] = useState(0);
  const [cpmAscensoresFinal, setCpmAscensoresFinal] = useState(0);
  const [cpmTotemsFinal, setCpmTotemsFinal] = useState(0);
  const [cpmCoworkFinal, setCpmCoworkFinal] = useState(0);
  const [cpmEsperaFinal, setCpmEsperaFinal] = useState(0);
  const [cpmTotalFinal, setCpmTotalFinal] = useState(0);
  const [descuentoGlobal, setDescuentoGlobal] = useState(0);
  const [selectedMoneda, setSelectedMoneda] = useState("");
  const [isInitialized, setIsInitialized] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [clientesLoading, setClientesLoading] = useState(true);
  const [, setHasProposalChanges] = useState(false);
  const [showDiscountModal, setShowDiscountModal] = useState(false);
  const [manualDiscountAmount, setManualDiscountAmount] = useState(0);
  const [finalAmount, setFinalAmount] = useState(0);
  const [originalAmount, setOriginalAmount] = useState(0);
  const [discountMethod, setDiscountMethod] = useState("finalAmount");
  const [discountPercentage, setDiscountPercentage] = useState(0);
  const manualDiscountPercentage =
    manualDiscountAmount > 0 && originalAmount > 0 ? (manualDiscountAmount / originalAmount) * 100 : 0;
  const sanitizeFileName = (str) => (str ? str.replace(/["*/:<>?\\|]/g, "_") : "");
  const [tipoCotizacion, setTipoCotizacion] = useState("");
  const [forceDollars, setForceDollars] = useState(false);
  const [forceRecalc, setForceRecalc] = useState(0);
  const [finalAmountStr, setFinalAmountStr] = useState(finalAmount.toString());
  const [manualDiscountAmountStr, setManualDiscountAmountStr] = useState(manualDiscountAmount.toString());
  const [discountPercentageStr, setDiscountPercentageStr] = useState(discountPercentage.toString());
  const [, setBaseInversionFinalTotal] = useState(0);
  const [discountType, setDiscountType] = useState("none");

  const { session, nombre, apellido, pais, rol, id: userId } = useAuthContext();
  const navigate = useNavigate();

  const linkFormMethods = useForm({
    defaultValues: {
      clientePublicitario: "",
      tipoCotizacion: "",
      campana: "",
      canal: "",
      mes_cierre: "",
      ano_cierre: new Date().getFullYear().toString(), // 2025
      mes_factura: "",
      ano_factura: new Date().getFullYear().toString(), // 2025
      estatus: "",
    },
  });

  const updateFormMethods = useForm({
    defaultValues: isEditMode
      ? {
          mes_cierre: opportunityData?.mes_cierre ? opportunityData.mes_cierre.split("-")[0] : "",
          ano_cierre: opportunityData?.mes_cierre
            ? opportunityData.mes_cierre.split("-")[1]
            : opportunityData?.ano || new Date().getFullYear().toString(),
          mes_factura: opportunityData?.mes_factura ? opportunityData.mes_factura.split("-")[0] : "",
          ano_factura: opportunityData?.mes_factura
            ? opportunityData.mes_factura.split("-")[1]
            : opportunityData?.ano || new Date().getFullYear().toString(),
          estatus: opportunityData?.estatus || "0%",
        }
      : {},
  });

  const {
    register: registerLink,
    handleSubmit: handleSubmitLink,
    formState: { errors: linkErrors },
    setValue: setLinkValue,
  } = linkFormMethods;

  const {
    register: registerUpdate,
    handleSubmit: handleSubmitUpdate,
    formState: { errors: updateErrors },
    watch: watchUpdate,
  } = updateFormMethods;

  const updateFormValues = watchUpdate();

  const meses = [
    { value: "1", label: "ENE" },
    { value: "2", label: "FEB" },
    { value: "3", label: "MAR" },
    { value: "4", label: "ABR" },
    { value: "5", label: "MAY" },
    { value: "6", label: "JUN" },
    { value: "7", label: "JUL" },
    { value: "8", label: "AGO" },
    { value: "9", label: "SEP" },
    { value: "10", label: "OCT" },
    { value: "11", label: "NOV" },
    { value: "12", label: "DIC" },
  ];

  const currentMonth = new Date().getMonth() + 1; // getMonth() devuelve 0-11, sumamos 1 para 1-12
  const orderedMeses = [
    ...meses.slice(currentMonth - 1), // Meses desde el actual hasta diciembre
    ...meses.slice(0, currentMonth - 1), // Meses desde enero hasta el mes anterior al actual
  ];

  const localString = (pais) =>
    ({
      Chile: "es-CL",
      Perú: "es-PE",
      Uruguay: "es-UY",
    })[pais] || "es-UY";

  const moneda = useCallback(
    (pais) =>
      ({
        Chile: "$",
        Perú: "S/",
        Uruguay: "$",
      })[pais] || "$",
    []
  );

  // const currencyCodeMap = {
  //   Chile: "CLP",
  //   Perú: "PEN",
  //   Uruguay: "UYU",
  // };

  const logos = {
    Chile: wecastLogo,
    Perú: visionaLogo,
    Uruguay: screenmediaLogo,
    Region: adigitalLogo,
  };

  const logo = useMemo(() => logos[pais] || visionaLogo, [pais]);

  const tiposDeCambio = {
    Uruguay: 42,
    Perú: 3.75,
    Chile: 950,
  };

  const operacionTextual = useCallback(
    (pais) =>
      ({
        Chile: "WECAST",
        Perú: "VISIONA",
        Uruguay: "SCREENMEDIA",
      })[pais] || "VISIONA",
    []
  );

  const validateData = useCallback(() => {
    if (plazo <= 0) {
      toast.error("El plazo debe ser mayor a 0");
      return false;
    }
    if (!["5", "10", "15", "20", "25", "30"].includes(frecuencia)) {
      toast.error("Selecciona una frecuencia válida (5, 10, 15, 20, 25 o 30)");
      return false;
    }
    // Check if at least one building is selected across any circuit
    if (
      (inventarioData.edificiosSeleccionadosAscensores?.length || 0) === 0 &&
      (inventarioData.edificiosSeleccionadosTotems?.length || 0) === 0 &&
      (inventarioData.edificiosSeleccionadosEspera?.length || 0) === 0 &&
      (inventarioData.edificiosSeleccionadosCowork?.length || 0) === 0
    ) {
      toast.error("Debes seleccionar al menos un edificio");
      return false;
    }
    if (horasSeleccionadas.horas <= 0) {
      toast.error("Las horas deben ser mayores a 0");
      return false;
    }
    if (duracion <= 0) {
      toast.error("La duración debe ser mayor a 0");
      return false;
    }
    if (!includeInstallingBuildings) {
      const selectedBuildingIds = [
        ...(inventarioData.edificiosSeleccionadosAscensores || []),
        ...(inventarioData.edificiosSeleccionadosTotems || []),
        ...(inventarioData.edificiosSeleccionadosCowork || []),
        ...(inventarioData.edificiosSeleccionadosEspera || []),
      ];
      const invalidBuildings = selectedBuildingIds.some((id) => {
        const edificio = edificios.find((e) => e.id === id);
        return edificio && (edificio.estado === "INSTALACIÓN" || edificio.estado === "REACTIVACIÓN");
      });
      if (invalidBuildings) {
        toast.error("No puedes incluir edificios en instalación o reactivación si la opción está desactivada.");
        return false;
      }
    }
    return true;
  }, [
    plazo,
    frecuencia,
    inventarioData.edificiosSeleccionadosAscensores,
    inventarioData.edificiosSeleccionadosTotems,
    inventarioData.edificiosSeleccionadosEspera,
    inventarioData.edificiosSeleccionadosCowork,
    horasSeleccionadas.horas,
    duracion,
    includeInstallingBuildings,
    edificios, // Nueva dependencia
  ]);

  function obtenerTipoDeCambio(pais) {
    return tiposDeCambio[pais];
  }

  const obtenerFechaActual = () => {
    const fecha = new Date();
    const year = fecha.getFullYear();
    const month = (fecha.getMonth() + 1).toString().padStart(2, "0");
    const day = fecha.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const generarCodigoAleatorio = () => {
    const letras = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let codigo = "";
    for (let i = 0; i < 6; i++) {
      codigo += letras.charAt(Math.floor(Math.random() * letras.length));
    }
    return codigo;
  };

  const validateDiscount = (inversionFinalTotal, discountAmount, finalAmount, rol) => {
    // Restrict discounts to superadmin, gerencia, and comercial only
    if (!["superadmin", "gerencia", "comercial"].includes(rol)) {
      return "Tu rol no tiene permiso para aplicar descuentos.";
    }

    let maxDiscount;
    if (rol === "superadmin" || rol === "gerencia") {
      maxDiscount = Infinity; // No limit for superadmin and gerencia
    } else if (rol === "comercial") {
      maxDiscount = inversionFinalTotal * 0.1; // 10% limit for comercial
    }

    if (discountAmount > maxDiscount) {
      return rol === "comercial"
        ? "El descuento no puede superar el 10% del monto original."
        : "Error en la validación del descuento.";
    }
    if (finalAmount < 0) {
      return "El monto final no puede ser negativo.";
    }
    if (finalAmount > inversionFinalTotal) {
      return "El monto final no puede ser mayor al monto original.";
    }
    return null;
  };

  const calculateProposalChanges = useCallback(() => {
    if (!initialData || !isInitialized) return false;

    const edificiosActualesArray = [
      ...(inventarioData.edificiosSeleccionadosAscensores || []),
      ...(inventarioData.edificiosSeleccionadosTotems || []),
      ...(inventarioData.edificiosSeleccionadosCowork || []),
      ...(inventarioData.edificiosSeleccionadosEspera || []),
    ].filter(Boolean);
    const uniqueEdificiosActualesArray = [...new Set(edificiosActualesArray)].sort((a, b) => a - b);
    const edificiosActuales = uniqueEdificiosActualesArray.join(",");

    const edificiosInicialesArray = (initialData.edificiosparticipantes || "").split(",").filter(Boolean).map(Number);
    const uniqueEdificiosInicialesArray = [...new Set(edificiosInicialesArray)].sort((a, b) => a - b);
    const edificiosIniciales = uniqueEdificiosInicialesArray.join(",");

    const ascensoresIdsActuales = (inventarioData.edificiosSeleccionadosAscensores || [])
      .sort((a, b) => a - b)
      .join(",");
    const totemsIdsActuales = (inventarioData.edificiosSeleccionadosTotems || []).sort((a, b) => a - b).join(",");
    const esperaIdsActuales = (inventarioData.edificiosSeleccionadosEspera || []).sort((a, b) => a - b).join(",");
    const coworkIdsActuales = (inventarioData.edificiosSeleccionadosCowork || []).sort((a, b) => a - b).join(",");

    const currentData = {
      edificiosparticipantes: edificiosActuales,
      pantallas_ascensores: ascensoresIdsActuales,
      pantallas_circulacion: totemsIdsActuales,
      pantallas_espera: esperaIdsActuales,
      pantallas_cowork: coworkIdsActuales,
      periodopauta: plazo || 0,
      formatopauta: frecuencia ? String(frecuencia) : "15",
      horas_pauta: horasSeleccionadas.horas || 14,
      intervalos: horasSeleccionadas.intervalos || [],
      options: horasSeleccionadas.options || [{ label: "FULL DAY | 07:00 - 21:00", hours: 14 }],
      duracion: duracion || 10,
      tipo: isProgrammaticSelected ? "p" : "d",
    };

    const proposalDifferences = {};

    if (currentData.edificiosparticipantes !== edificiosIniciales) {
      proposalDifferences.edificiosparticipantes = true;
    }
    if (currentData.pantallas_ascensores !== initialData.pantallas_ascensores) {
      proposalDifferences.pantallas_ascensores = true;
    }
    if (currentData.pantallas_circulacion !== initialData.pantallas_circulacion) {
      proposalDifferences.pantallas_circulacion = true;
    }
    if (currentData.pantallas_espera !== initialData.pantallas_espera) {
      proposalDifferences.pantallas_espera = true;
    }
    if (currentData.pantallas_cowork !== initialData.pantallas_cowork) {
      proposalDifferences.pantallas_cowork = true;
    }
    if (currentData.periodopauta !== initialData.periodopauta) {
      proposalDifferences.periodopauta = true;
    }
    if (currentData.formatopauta !== initialData.formatopauta) {
      proposalDifferences.formatopauta = true;
    }
    if (currentData.horas_pauta !== initialData.horas_pauta) {
      proposalDifferences.horas_pauta = true;
    }
    if (JSON.stringify(currentData.intervalos) !== JSON.stringify(initialData.intervalos)) {
      proposalDifferences.intervalos = true;
    }
    if (JSON.stringify(currentData.options) !== JSON.stringify(initialData.options)) {
      proposalDifferences.options = true;
    }
    if (currentData.duracion !== initialData.duracion) {
      proposalDifferences.duracion = true;
    }
    if (currentData.tipo !== initialData.tipo) {
      proposalDifferences.tipo = true;
    }

    return Object.keys(proposalDifferences).length > 0;
  }, [
    initialData,
    isInitialized,
    inventarioData,
    plazo,
    frecuencia,
    horasSeleccionadas,
    duracion,
    isProgrammaticSelected,
  ]);

  useEffect(() => {
    if (isEditMode && opportunityData) {
      const hasManualDiscount = opportunityData.has_manual_discount === true;
      const savedDiscountAmount = parseFloat(opportunityData.manual_discount_amount) || 0;
      const savedOriginalAmount = parseFloat(opportunityData.original_amount) || 0;
      const savedPercentage = savedOriginalAmount > 0 ? (savedDiscountAmount / savedOriginalAmount) * 100 : 0;

      setOriginalAmount(savedOriginalAmount);
      setDiscountPercentage(savedPercentage);
      if (hasManualDiscount) {
        setManualDiscountAmount(savedDiscountAmount);
        setFinalAmount(parseFloat(opportunityData.importe) || 0);
        setFinalAmountStr((parseFloat(opportunityData.importe) || 0).toString());
        setManualDiscountAmountStr(savedDiscountAmount.toString());
        setDiscountPercentageStr(savedPercentage.toString());
      }
    }
  }, [isEditMode, opportunityData]);

  useEffect(() => {
    const fetchData = async () => {
      setClientesLoading(true);
      try {
        const [clientesData] = await Promise.all([getClientes({ pais })]);
        let filteredClientes = clientesData;
        if (pais !== "Perú") {
          if (rol === "comercial") {
            filteredClientes = clientesData.filter((cliente) => String(cliente.ejecutivo) === String(userId));
          } else if (rol === "gerencia" || rol === "superadmin") {
            filteredClientes = clientesData;
          }
        }
        setClientes(filteredClientes);
      } catch (error) {
        if (process.env.NODE_ENV !== "production") {
          console.error("Error al obtener datos:", error);
        }
        toast.error("No se pudieron cargar los datos.");
      } finally {
        setClientesLoading(false);
      }
    };
    fetchData();
  }, [pais, rol, userId]);

  const renderClientesOptions = () => {
    const clientesOrdenados = [...new Set(clientes.map((cliente) => cliente.nombre))].sort();
    return clientesOrdenados.map((cliente, index) => (
      <option key={index} value={cliente}>
        {cliente}
      </option>
    ));
  };

  const frecuenciaNumero = parseInt(frecuencia, 10);

  useEffect(() => {
    if (inventarioData) {
      setAscensoresSeleccionados(inventarioData.ascensoresSeleccionados || 0);
      setTotemsSeleccionados(inventarioData.totemsSeleccionados || 0);
      setCoworkSeleccionados(inventarioData.coworkSeleccionados || 0);
      setEsperaSeleccionados(inventarioData.esperaSeleccionados || 0);
      setAudienciaSeleccionadaAscensor(inventarioData.audienciaSeleccionadaAscensor || 0);
      setAudienciaSeleccionadaTotems(inventarioData.audienciaSeleccionadaTotems || 0);
      setAudienciaSeleccionadaCowork(inventarioData.audienciaSeleccionadaCowork || 0);
      setAudienciaSeleccionadaEspera(inventarioData.audienciaSeleccionadaEspera || 0);
      setAudienciaSeleccionadaTotal(inventarioData.audienciaSeleccionadaTotal || 0);
      setEdificiosSeleccionadosAscensores(inventarioData.edificiosSeleccionadosAscensores?.length || 0);
      setEdificiosSeleccionadosTotems(inventarioData.edificiosSeleccionadosTotems?.length || 0);
      setEdificiosSeleccionadosCowork(inventarioData.edificiosSeleccionadosCowork?.length || 0);
      setEdificiosSeleccionadosEspera(inventarioData.edificiosSeleccionadosEspera?.length || 0);
      const totalEdificiosUnicos = new Set([
        ...(Array.isArray(inventarioData.edificiosSeleccionadosAscensores)
          ? inventarioData.edificiosSeleccionadosAscensores
          : []),
        ...(Array.isArray(inventarioData.edificiosSeleccionadosTotems)
          ? inventarioData.edificiosSeleccionadosTotems
          : []),
        ...(Array.isArray(inventarioData.edificiosSeleccionadosCowork)
          ? inventarioData.edificiosSeleccionadosCowork
          : []),
        ...(Array.isArray(inventarioData.edificiosSeleccionadosEspera)
          ? inventarioData.edificiosSeleccionadosEspera
          : []),
      ]).size;
      setEdificiosUnicosTotal(totalEdificiosUnicos);
    }
  }, [inventarioData]);

  useEffect(() => {
    setSelectedMoneda(moneda(pais));
  }, [pais, moneda]);

  useEffect(() => {
    if (isEditMode && opportunityData) {
      const ascensoresIds = opportunityData.pantallas_ascensores
        ? opportunityData.pantallas_ascensores.split(",").filter(Boolean).map(Number)
        : [];
      const totemsIds = opportunityData.pantallas_circulacion
        ? opportunityData.pantallas_circulacion.split(",").filter(Boolean).map(Number)
        : [];
      const esperaIds = opportunityData.pantallas_espera
        ? opportunityData.pantallas_espera.split(",").filter(Boolean).map(Number)
        : [];
      const coworkIds = opportunityData.pantallas_cowork
        ? opportunityData.pantallas_cowork.split(",").filter(Boolean).map(Number)
        : [];

      let ascensoresSeleccionados = 0;
      let totemsSeleccionados = 0;
      let esperaSeleccionados = 0;
      let coworkSeleccionados = 0;
      let audienciaSeleccionadaAscensor = 0;
      let audienciaSeleccionadaTotems = 0;
      let audienciaSeleccionadaEspera = 0;
      let audienciaSeleccionadaCowork = 0;

      const fetchEdificios = async () => {
        try {
          let edificiosData = await getEdificios({ pais });

          // Aplicar filtro basado en includeInstallingBuildings
          edificiosData = includeInstallingBuildings
            ? edificiosData
            : edificiosData.filter((edificio) => edificio.estado === "OPERATIVO");

          edificiosData.forEach((edificio) => {
            if (ascensoresIds.includes(edificio.id)) {
              ascensoresSeleccionados += edificio.pantallas || 0;
              audienciaSeleccionadaAscensor += edificio.personas || 0;
            }
            if (totemsIds.includes(edificio.id)) {
              totemsSeleccionados += edificio.totems || 0;
              audienciaSeleccionadaTotems += edificio.personas || 0;
            }
            if (esperaIds.includes(edificio.id)) {
              esperaSeleccionados += edificio.espera || 0;
              audienciaSeleccionadaEspera += edificio.personas || 0;
            }
            if (coworkIds.includes(edificio.id)) {
              coworkSeleccionados += edificio.cowork || 0;
              audienciaSeleccionadaCowork += edificio.personas || 0;
            }
          });

          const audienciaSeleccionadaTotal =
            audienciaSeleccionadaAscensor +
            audienciaSeleccionadaTotems +
            audienciaSeleccionadaEspera +
            audienciaSeleccionadaCowork;

          setAscensoresSeleccionados(ascensoresSeleccionados);
          setTotemsSeleccionados(totemsSeleccionados);
          setEsperaSeleccionados(esperaSeleccionados);
          setCoworkSeleccionados(coworkSeleccionados);
          setAudienciaSeleccionadaAscensor(audienciaSeleccionadaAscensor);
          setAudienciaSeleccionadaTotems(audienciaSeleccionadaTotems);
          setAudienciaSeleccionadaEspera(audienciaSeleccionadaEspera);
          setAudienciaSeleccionadaCowork(audienciaSeleccionadaCowork);
          setAudienciaSeleccionadaTotal(audienciaSeleccionadaTotal);
          setEdificiosSeleccionadosAscensores(ascensoresIds.length);
          setEdificiosSeleccionadosTotems(totemsIds.length);
          setEdificiosSeleccionadosEspera(esperaIds.length);
          setEdificiosSeleccionadosCowork(coworkIds.length);

          const totalEdificiosUnicos = new Set([...ascensoresIds, ...totemsIds, ...esperaIds, ...coworkIds]).size;
          setEdificiosUnicosTotal(totalEdificiosUnicos);

          // Nueva línea para cargar forceDollars desde opportunityData
          setForceDollars(opportunityData.moneda_dolar || false);

          // Nueva lógica para cargar estados de descuento manual y tipo
          const hasManualDiscount = opportunityData.has_manual_discount === true;
          const savedDiscountAmount = parseFloat(opportunityData.manual_discount_amount) || 0;
          const savedOriginalAmount = parseFloat(opportunityData.original_amount) || 0;
          const savedPercentage = savedOriginalAmount > 0 ? (savedDiscountAmount / savedOriginalAmount) * 100 : 0;
          const savedFinalAmount = parseFloat(opportunityData.importe) || 0;

          setOriginalAmount(savedOriginalAmount);
          setDiscountPercentage(savedPercentage);
          if (hasManualDiscount) {
            setManualDiscountAmount(savedDiscountAmount);
            setFinalAmount(savedFinalAmount);
            setFinalAmountStr(savedFinalAmount.toString());
            setManualDiscountAmountStr(savedDiscountAmount.toString());
            setDiscountPercentageStr(savedPercentage.toString());
            setDiscountType("amount"); // Asumimos 'amount' por default en carga; ajusta si sabes el tipo original
            setInversionFinalTotal(savedFinalAmount);
          } else {
            setDiscountType("none");
          }

          const initial = {
            edificiosparticipantes: opportunityData.edificiosparticipantes || "",
            pantallas_ascensores: opportunityData.pantallas_ascensores || "",
            pantallas_circulacion: opportunityData.pantallas_circulacion || "",
            pantallas_espera: opportunityData.pantallas_espera || "",
            pantallas_cowork: opportunityData.pantallas_cowork || "",
            periodopauta: opportunityData.periodopauta || 0,
            formatopauta: opportunityData.formatopauta ? String(opportunityData.formatopauta) : "15",
            horas_pauta: opportunityData.horas_pauta || 14,
            intervalos: opportunityData.intervalos ? JSON.parse(opportunityData.intervalos) : [],
            options: opportunityData.options
              ? JSON.parse(opportunityData.options)
              : [{ label: "FULL DAY | 07:00 - 21:00", hours: 14 }],
            duracion: opportunityData.duracion || 10,
            tipo: opportunityData.tipo || "d",
            mes_cierre: opportunityData.mes_cierre ? String(parseInt(opportunityData.mes_cierre, 10)) : "",
            mes_factura: opportunityData.mes_factura ? String(parseInt(opportunityData.mes_factura, 10)) : "",
            estatus: opportunityData.estatus || "0%",
            importe: opportunityData.importe || 0,
          };
          setInitialData(initial);
          setIsInitialized(true);
          setForceRecalc((prev) => prev + 1); // Nueva: Forzar recálculo después de carga inicial
        } catch (error) {
          console.error("Error al cargar edificios para inicialización:", error);
          toast.error("Error al inicializar los datos de la oportunidad.");
        }
      };

      fetchEdificios();
    }
  }, [isEditMode, opportunityData, pais, includeInstallingBuildings]);

  // eslint-disable-next-line no-unused-vars
  const { intervalos, horas, options } = horasSeleccionadas;

  useEffect(() => {
    const { intervalos, horas, options } = horasSeleccionadas;

    // Calcular horasFinal
    let newHorasFinal = 0;
    if (intervalos && intervalos.length > 0) {
      newHorasFinal = horas || 0;
    } else if (options && options.length > 0) {
      newHorasFinal = options[0].hours || 0;
    } else {
      newHorasFinal = 14;
    }
    setHorasFinal(newHorasFinal);

    // Calcular salidas
    const newSalidasAscensores = ascensoresSeleccionados * plazo * frecuenciaNumero * newHorasFinal;
    const newSalidasTotems = totemsSeleccionados * plazo * frecuenciaNumero * newHorasFinal;
    const newSalidasCowork = coworkSeleccionados * plazo * frecuenciaNumero * newHorasFinal;
    const newSalidasEspera = esperaSeleccionados * plazo * frecuenciaNumero * newHorasFinal;
    setSalidasAscensores(newSalidasAscensores);
    setSalidasTotems(newSalidasTotems);
    setSalidasCowork(newSalidasCowork);
    setSalidasEspera(newSalidasEspera);

    // Definir constantes
    const valle = 0.15;
    const picoMañana = 0.25;
    const picoMediodia = 0.35;
    const picoTarde = 0.25;

    // Calcular contactos totales
    const contactosTotalAscensores = audienciaSeleccionadaAscensor * 7.48;
    const contactosTotalTotems = audienciaSeleccionadaTotems * 7.48;
    const contactosTotalCowork = audienciaSeleccionadaCowork * 7.48;
    const contactosTotalEspera = audienciaSeleccionadaEspera * 7.48;
    const contactosValleAscensores = contactosTotalAscensores * valle;
    const contactosMañanaAscensores = contactosTotalAscensores * picoMañana;
    const contactosMediodiaAscensores = contactosTotalAscensores * picoMediodia;
    const contactosTardeAscensores = contactosTotalAscensores * picoTarde;
    const contactosValleTotems = contactosTotalTotems * valle;
    const contactosMañanaTotems = contactosTotalTotems * picoMañana;
    const contactosMediodiaTotems = contactosTotalTotems * picoMediodia;
    const contactosTardeTotems = contactosTotalTotems * picoTarde;
    const contactosValleCowork = contactosTotalCowork * valle;
    const contactosMañanaCowork = contactosTotalCowork * picoMañana;
    const contactosMediodiaCowork = contactosTotalCowork * picoMediodia;
    const contactosTardeCowork = contactosTotalCowork * picoTarde;
    const contactosValleEspera = contactosTotalEspera * valle;
    const contactosMañanaEspera = contactosTotalEspera * picoMañana;
    const contactosMediodiaEspera = contactosTotalEspera * picoMediodia;
    const contactosTardeEspera = contactosTotalEspera * picoTarde;

    // Calcular contactos por hora
    const contactosVallexHoraAscensores = contactosValleAscensores / 8;
    const contactosMañanaxHoraAscensores = contactosMañanaAscensores / 2;
    const contactosMediodiaxHoraAscensores = contactosMediodiaAscensores / 2;
    const contactosTardexHoraAscensores = contactosTardeAscensores / 2;
    const contactosVallexHoraTotems = contactosValleTotems / 8;
    const contactosMañanaxHoraTotems = contactosMañanaTotems / 2;
    const contactosMediodiaxHoraTotems = contactosMediodiaTotems / 2;
    const contactosTardexHoraTotems = contactosTardeTotems / 2;
    const contactosVallexHoraCowork = contactosValleCowork / 8;
    const contactosMañanaxHoraCowork = contactosMañanaCowork / 2;
    const contactosMediodiaxHoraCowork = contactosMediodiaCowork / 2;
    const contactosTardexHoraCowork = contactosTardeCowork / 2;
    const contactosVallexHoraEspera = contactosValleEspera / 8;
    const contactosMañanaxHoraEspera = contactosMañanaEspera / 2;
    const contactosMediodiaxHoraEspera = contactosMediodiaEspera / 2;
    const contactosTardexHoraEspera = contactosTardeEspera / 2;

    // Calcular contactos por intervalo
    const contactosVallexIntervaloAscensores = contactosVallexHoraAscensores / 2;
    const contactosMañanaxIntervaloAscensores = contactosMañanaxHoraAscensores / 2;
    const contactosMediodiaxIntervaloAscensores = contactosMediodiaxHoraAscensores / 2;
    const contactosTardexIntervaloAscensores = contactosTardexHoraAscensores / 2;
    const contactosVallexIntervaloTotems = contactosVallexHoraTotems / 2;
    const contactosMañanaxIntervaloTotems = contactosMañanaxHoraTotems / 2;
    const contactosMediodiaxIntervaloTotems = contactosMediodiaxHoraTotems / 2;
    const contactosTardexIntervaloTotems = contactosTardexHoraTotems / 2;
    const contactosVallexIntervaloCowork = contactosVallexHoraCowork / 2;
    const contactosMañanaxIntervaloCowork = contactosMañanaxHoraCowork / 2;
    const contactosMediodiaxIntervaloCowork = contactosMediodiaxHoraCowork / 2;
    const contactosTardexIntervaloCowork = contactosTardexHoraCowork / 2;
    const contactosVallexIntervaloEspera = contactosVallexHoraEspera / 2;
    const contactosMañanaxIntervaloEspera = contactosMañanaxHoraEspera / 2;
    const contactosMediodiaxIntervaloEspera = contactosMediodiaxHoraEspera / 2;
    const contactosTardexIntervaloEspera = contactosTardexHoraEspera / 2;

    // Calcular contactos por intervalo por pantalla
    const contactosPorIntervaloPorPantallaValleAscensores = ascensoresSeleccionados
      ? contactosVallexIntervaloAscensores / ascensoresSeleccionados
      : 0;
    const contactosPorIntervaloPorPantallaMañanaAscensores = ascensoresSeleccionados
      ? contactosMañanaxIntervaloAscensores / ascensoresSeleccionados
      : 0;
    const contactosPorIntervaloPorPantallaMediodiaAscensores = ascensoresSeleccionados
      ? contactosMediodiaxIntervaloAscensores / ascensoresSeleccionados
      : 0;
    const contactosPorIntervaloPorPantallaTardeAscensores = ascensoresSeleccionados
      ? contactosTardexIntervaloAscensores / ascensoresSeleccionados
      : 0;
    const contactosPorIntervaloPorPantallaValleTotems = totemsSeleccionados
      ? contactosVallexIntervaloTotems / totemsSeleccionados
      : 0;
    const contactosPorIntervaloPorPantallaMañanaTotems = totemsSeleccionados
      ? contactosMañanaxIntervaloTotems / totemsSeleccionados
      : 0;
    const contactosPorIntervaloPorPantallaMediodiaTotems = totemsSeleccionados
      ? contactosMediodiaxIntervaloTotems / totemsSeleccionados
      : 0;
    const contactosPorIntervaloPorPantallaTardeTotems = totemsSeleccionados
      ? contactosTardexIntervaloTotems / totemsSeleccionados
      : 0;
    const contactosPorIntervaloPorPantallaValleCowork = coworkSeleccionados
      ? contactosVallexIntervaloCowork / coworkSeleccionados
      : 0;
    const contactosPorIntervaloPorPantallaMañanaCowork = coworkSeleccionados
      ? contactosMañanaxIntervaloCowork / coworkSeleccionados
      : 0;
    const contactosPorIntervaloPorPantallaMediodiaCowork = coworkSeleccionados
      ? contactosMediodiaxIntervaloCowork / coworkSeleccionados
      : 0;
    const contactosPorIntervaloPorPantallaTardeCowork = coworkSeleccionados
      ? contactosTardexIntervaloCowork / coworkSeleccionados
      : 0;
    const contactosPorIntervaloPorPantallaValleEspera = esperaSeleccionados
      ? contactosVallexIntervaloEspera / esperaSeleccionados
      : 0;
    const contactosPorIntervaloPorPantallaMañanaEspera = esperaSeleccionados
      ? contactosMañanaxIntervaloEspera / esperaSeleccionados
      : 0;
    const contactosPorIntervaloPorPantallaMediodiaEspera = esperaSeleccionados
      ? contactosMediodiaxIntervaloEspera / esperaSeleccionados
      : 0;
    const contactosPorIntervaloPorPantallaTardeEspera = esperaSeleccionados
      ? contactosTardexIntervaloEspera / esperaSeleccionados
      : 0;

    // Contar intervalos
    let countValle = 0;
    let countMañana = 0;
    let countMediodia = 0;
    let countTarde = 0;
    intervalos.forEach((intervalo) => {
      if (
        intervalo === "08:00 - 08:30" ||
        intervalo === "08:30 - 09:00" ||
        intervalo === "09:00 - 09:30" ||
        intervalo === "09:30 - 10:00"
      ) {
        countMañana++;
      } else if (
        intervalo === "12:30 - 13:00" ||
        intervalo === "13:00 - 13:30" ||
        intervalo === "13:30 - 14:00" ||
        intervalo === "14:00 - 14:30"
      ) {
        countMediodia++;
      } else if (
        intervalo === "17:00 - 17:30" ||
        intervalo === "17:30 - 18:00" ||
        intervalo === "18:00 - 18:30" ||
        intervalo === "18:30 - 19:00"
      ) {
        countTarde++;
      } else {
        countValle++;
      }
    });

    // Calcular total de contactos por periodo
    const totalContactosValleAscensores =
      contactosPorIntervaloPorPantallaValleAscensores * countValle * plazo * ascensoresSeleccionados;
    const totalContactosMañanaAscensores =
      contactosPorIntervaloPorPantallaMañanaAscensores * countMañana * plazo * ascensoresSeleccionados;
    const totalContactosMediodiaAscensores =
      contactosPorIntervaloPorPantallaMediodiaAscensores * countMediodia * plazo * ascensoresSeleccionados;
    const totalContactosTardeAscensores =
      contactosPorIntervaloPorPantallaTardeAscensores * countTarde * plazo * ascensoresSeleccionados;
    const totalContactosValleTotems =
      contactosPorIntervaloPorPantallaValleTotems * countValle * plazo * totemsSeleccionados;
    const totalContactosMañanaTotems =
      contactosPorIntervaloPorPantallaMañanaTotems * countMañana * plazo * totemsSeleccionados;
    const totalContactosMediodiaTotems =
      contactosPorIntervaloPorPantallaMediodiaTotems * countMediodia * plazo * totemsSeleccionados;
    const totalContactosTardeTotems =
      contactosPorIntervaloPorPantallaTardeTotems * countTarde * plazo * totemsSeleccionados;
    const totalContactosValleCowork =
      contactosPorIntervaloPorPantallaValleCowork * countValle * plazo * coworkSeleccionados;
    const totalContactosMañanaCowork =
      contactosPorIntervaloPorPantallaMañanaCowork * countMañana * plazo * coworkSeleccionados;
    const totalContactosMediodiaCowork =
      contactosPorIntervaloPorPantallaMediodiaCowork * countMediodia * plazo * coworkSeleccionados;
    const totalContactosTardeCowork =
      contactosPorIntervaloPorPantallaTardeCowork * countTarde * plazo * coworkSeleccionados;
    const totalContactosValleEspera =
      contactosPorIntervaloPorPantallaValleEspera * countValle * plazo * esperaSeleccionados;
    const totalContactosMañanaEspera =
      contactosPorIntervaloPorPantallaMañanaEspera * countMañana * plazo * esperaSeleccionados;
    const totalContactosMediodiaEspera =
      contactosPorIntervaloPorPantallaMediodiaEspera * countMediodia * plazo * esperaSeleccionados;
    const totalContactosTardeEspera =
      contactosPorIntervaloPorPantallaTardeEspera * countTarde * plazo * esperaSeleccionados;

    // Calcular total de contactos de campaña
    let totalContactosCampañaAscensores = 0;
    if (intervalos && intervalos.length > 0) {
      totalContactosCampañaAscensores =
        totalContactosValleAscensores +
        totalContactosMañanaAscensores +
        totalContactosMediodiaAscensores +
        totalContactosTardeAscensores;
    } else if (options && options.length > 0) {
      if (options[0].label.includes("FULL")) {
        totalContactosCampañaAscensores = audienciaSeleccionadaAscensor * 7.48 * plazo;
      } else if (options[0].label.includes("AM") || options[0].label.includes("PM")) {
        totalContactosCampañaAscensores = ((audienciaSeleccionadaAscensor * 7.48) / 2) * plazo;
      }
    }
    let totalContactosCampañaTotems = 0;
    if (intervalos && intervalos.length > 0) {
      totalContactosCampañaTotems =
        totalContactosValleTotems +
        totalContactosMañanaTotems +
        totalContactosMediodiaTotems +
        totalContactosTardeTotems;
    } else if (options && options.length > 0) {
      if (options[0].label.includes("FULL")) {
        totalContactosCampañaTotems = audienciaSeleccionadaTotems * 7.48 * plazo;
      } else if (options[0].label.includes("AM") || options[0].label.includes("PM")) {
        totalContactosCampañaTotems = ((audienciaSeleccionadaTotems * 7.48) / 2) * plazo;
      }
    }
    let totalContactosCampañaCowork = 0;
    if (intervalos && intervalos.length > 0) {
      totalContactosCampañaCowork =
        totalContactosValleCowork +
        totalContactosMañanaCowork +
        totalContactosMediodiaCowork +
        totalContactosTardeCowork;
    } else if (options && options.length > 0) {
      if (options[0].label.includes("FULL")) {
        totalContactosCampañaCowork = audienciaSeleccionadaCowork * 7.48 * plazo;
      } else if (options[0].label.includes("AM") || options[0].label.includes("PM")) {
        totalContactosCampañaCowork = ((audienciaSeleccionadaCowork * 7.48) / 2) * plazo;
      }
    }
    const totalContactosCampañaEspera =
      intervalos && intervalos.length > 0
        ? totalContactosValleEspera +
          totalContactosMañanaEspera +
          totalContactosMediodiaEspera +
          totalContactosTardeEspera
        : options && options.length > 0 && options[0].label.includes("FULL")
          ? audienciaSeleccionadaEspera * 7.48 * plazo
          : options && options.length > 0 && (options[0].label.includes("AM") || options[0].label.includes("PM"))
            ? ((audienciaSeleccionadaEspera * 7.48) / 2) * plazo
            : 0;

    // Definir coeficientes de frecuencia
    const coeficientesFrecuencia = {
      5: { valle: 0.0556, picoMañana: 0.1042, picoMediodia: 0.125, picoTarde: 0.1042 },
      10: { valle: 0.1111, picoMañana: 0.2083, picoMediodia: 0.25, picoTarde: 0.2083 },
      15: { valle: 0.1667, picoMañana: 0.3125, picoMediodia: 0.375, picoTarde: 0.3125 },
      20: { valle: 0.2222, picoMañana: 0.4167, picoMediodia: 0.5, picoTarde: 0.4167 },
      25: { valle: 0.2778, picoMañana: 0.5208, picoMediodia: 0.625, picoTarde: 0.5208 },
      30: { valle: 0.3333, picoMañana: 0.625, picoMediodia: 0.75, picoTarde: 0.625 },
    };

    // Calcular impactos totales
    let newImpactosTotalAscensores = 0;
    if (intervalos && intervalos.length > 0) {
      const coeficientes = coeficientesFrecuencia[frecuenciaNumero] || {};
      if (countValle > 0) newImpactosTotalAscensores += totalContactosValleAscensores * (coeficientes.valle || 0);
      if (countMañana > 0 || countTarde > 0)
        newImpactosTotalAscensores +=
          (totalContactosMañanaAscensores + totalContactosTardeAscensores) * (coeficientes.picoMañana || 0);
      if (countMediodia > 0)
        newImpactosTotalAscensores += totalContactosMediodiaAscensores * (coeficientes.picoMediodia || 0);
    } else if (options && options.length > 0 && options[0].label.includes("FULL")) {
      const coeficientes = coeficientesFrecuencia[frecuenciaNumero] || {};
      newImpactosTotalAscensores =
        totalContactosCampañaAscensores * valle * (coeficientes.valle || 0) +
        totalContactosCampañaAscensores * picoMañana * (coeficientes.picoMañana || 0) +
        totalContactosCampañaAscensores * picoMediodia * (coeficientes.picoMediodia || 0) +
        totalContactosCampañaAscensores * picoTarde * (coeficientes.picoTarde || 0);
    } else if (options && options.length > 0 && (options[0].label.includes("AM") || options[0].label.includes("PM"))) {
      const coeficientes = coeficientesFrecuencia[frecuenciaNumero] || {};
      newImpactosTotalAscensores =
        totalContactosCampañaAscensores * valle * (coeficientes.valle || 0) +
        totalContactosCampañaAscensores * picoMañana * (coeficientes.picoMañana || 0) +
        totalContactosCampañaAscensores * picoMediodia * (coeficientes.picoMediodia || 0) +
        totalContactosCampañaAscensores * picoTarde * (coeficientes.picoTarde || 0);
    }
    newImpactosTotalAscensores = Math.round(newImpactosTotalAscensores * 100) / 100;
    setImpactosTotalAscensores(newImpactosTotalAscensores);

    let newImpactosTotalTotems = 0;
    if (intervalos && intervalos.length > 0) {
      const coeficientes = coeficientesFrecuencia[frecuenciaNumero] || {};
      if (countValle > 0) newImpactosTotalTotems += totalContactosValleTotems * (coeficientes.valle || 0);
      if (countMañana > 0 || countTarde > 0)
        newImpactosTotalTotems +=
          (totalContactosMañanaTotems + totalContactosTardeTotems) * (coeficientes.picoMañana || 0);
      if (countMediodia > 0) newImpactosTotalTotems += totalContactosMediodiaTotems * (coeficientes.picoMediodia || 0);
    } else if (options && options.length > 0 && options[0].label.includes("FULL")) {
      const coeficientes = coeficientesFrecuencia[frecuenciaNumero] || {};
      newImpactosTotalTotems =
        totalContactosCampañaTotems * valle * (coeficientes.valle || 0) +
        totalContactosCampañaTotems * picoMañana * (coeficientes.picoMañana || 0) +
        totalContactosCampañaTotems * picoMediodia * (coeficientes.picoMediodia || 0) +
        totalContactosCampañaTotems * picoTarde * (coeficientes.picoTarde || 0);
    } else if (options && options.length > 0 && (options[0].label.includes("AM") || options[0].label.includes("PM"))) {
      const coeficientes = coeficientesFrecuencia[frecuenciaNumero] || {};
      newImpactosTotalTotems =
        totalContactosCampañaTotems * valle * (coeficientes.valle || 0) +
        totalContactosCampañaTotems * picoMañana * (coeficientes.picoMañana || 0) +
        totalContactosCampañaTotems * picoMediodia * (coeficientes.picoMediodia || 0) +
        totalContactosCampañaTotems * picoTarde * (coeficientes.picoTarde || 0);
    }
    newImpactosTotalTotems = Math.round(newImpactosTotalTotems * 100) / 100;
    setImpactosTotalTotems(newImpactosTotalTotems);

    let newImpactosTotalCowork = 0;
    if (intervalos && intervalos.length > 0) {
      const coeficientes = coeficientesFrecuencia[frecuenciaNumero] || {};
      if (countValle > 0) newImpactosTotalCowork += totalContactosValleCowork * (coeficientes.valle || 0);
      if (countMañana > 0 || countTarde > 0)
        newImpactosTotalCowork +=
          (totalContactosMañanaCowork + totalContactosTardeCowork) * (coeficientes.picoMañana || 0);
      if (countMediodia > 0) newImpactosTotalCowork += totalContactosMediodiaCowork * (coeficientes.picoMediodia || 0);
    } else if (options && options.length > 0 && options[0].label.includes("FULL")) {
      const coeficientes = coeficientesFrecuencia[frecuenciaNumero] || {};
      newImpactosTotalCowork =
        totalContactosCampañaCowork * valle * (coeficientes.valle || 0) +
        totalContactosCampañaCowork * picoMañana * (coeficientes.picoMañana || 0) +
        totalContactosCampañaCowork * picoMediodia * (coeficientes.picoMediodia || 0) +
        totalContactosCampañaCowork * picoTarde * (coeficientes.picoTarde || 0);
    } else if (options && options.length > 0 && (options[0].label.includes("AM") || options[0].label.includes("PM"))) {
      const coeficientes = coeficientesFrecuencia[frecuenciaNumero] || {};
      newImpactosTotalCowork =
        totalContactosCampañaCowork * valle * (coeficientes.valle || 0) +
        totalContactosCampañaCowork * picoMañana * (coeficientes.picoMañana || 0) +
        totalContactosCampañaCowork * picoMediodia * (coeficientes.picoMediodia || 0) +
        totalContactosCampañaCowork * picoTarde * (coeficientes.picoTarde || 0);
    }
    newImpactosTotalCowork = Math.round(newImpactosTotalCowork * 100) / 100;
    setImpactosTotalCowork(newImpactosTotalCowork);

    let newImpactosTotalEspera = 0;
    if (intervalos && intervalos.length > 0) {
      const coeficientes = coeficientesFrecuencia[frecuenciaNumero] || {};
      if (countValle > 0) newImpactosTotalEspera += totalContactosValleEspera * (coeficientes.valle || 0);
      if (countMañana > 0 || countTarde > 0)
        newImpactosTotalEspera +=
          (totalContactosMañanaEspera + totalContactosTardeEspera) * (coeficientes.picoMañana || 0);
      if (countMediodia > 0) newImpactosTotalEspera += totalContactosMediodiaEspera * (coeficientes.picoMediodia || 0);
    } else if (options && options.length > 0 && options[0].label.includes("FULL")) {
      const coeficientes = coeficientesFrecuencia[frecuenciaNumero] || {};
      newImpactosTotalEspera =
        totalContactosCampañaEspera * valle * (coeficientes.valle || 0) +
        totalContactosCampañaEspera * picoMañana * (coeficientes.picoMañana || 0) +
        totalContactosCampañaEspera * picoMediodia * (coeficientes.picoMediodia || 0) +
        totalContactosCampañaEspera * picoTarde * (coeficientes.picoTarde || 0);
    } else if (options && options.length > 0 && (options[0].label.includes("AM") || options[0].label.includes("PM"))) {
      const coeficientes = coeficientesFrecuencia[frecuenciaNumero] || {};
      newImpactosTotalEspera =
        totalContactosCampañaEspera * valle * (coeficientes.valle || 0) +
        totalContactosCampañaEspera * picoMañana * (coeficientes.picoMañana || 0) +
        totalContactosCampañaEspera * picoMediodia * (coeficientes.picoMediodia || 0) +
        totalContactosCampañaEspera * picoTarde * (coeficientes.picoTarde || 0);
    }
    newImpactosTotalEspera = Math.round(newImpactosTotalEspera * 100) / 100;
    setImpactosTotalEspera(newImpactosTotalEspera);

    // Calcular incidencia de duración
    let duracionIncidenciaCotizacion;
    if (duracion === 6) duracionIncidenciaCotizacion = 1;
    else if (duracion === 7) duracionIncidenciaCotizacion = 1.0125;
    else if (duracion === 8) duracionIncidenciaCotizacion = 1.025;
    else if (duracion === 9) duracionIncidenciaCotizacion = 1.0375;
    else if (duracion === 10) duracionIncidenciaCotizacion = 1.05;
    else if (duracion === 11) duracionIncidenciaCotizacion = 1.0625;
    else if (duracion === 12) duracionIncidenciaCotizacion = 1.075;
    else if (duracion === 13) duracionIncidenciaCotizacion = 1.0875;
    else if (duracion === 14) duracionIncidenciaCotizacion = 1.1;
    else if (duracion === 15) duracionIncidenciaCotizacion = 1.1125;
    else duracionIncidenciaCotizacion = 0;
    const cpmReferencia = 6.9 * duracionIncidenciaCotizacion;

    // CPM Ascensores
    const exchange = obtenerTipoDeCambio(pais);
    const multiplier =
      intervalos.length > 0
        ? 2.5
        : options && options.length > 0 && (options[0].label.includes("AM") || options[0].label.includes("PM"))
          ? 1.5
          : 1;
    const cpmAscensores = (cpmReferencia * (forceDollars ? 1 : exchange) * multiplier) / 1000;
    const cpmTotems = cpmAscensores * 0.9;
    const cpmCowork = cpmAscensores * 0.9;
    const cpmEspera = cpmAscensores * 0.9;

    // Inversiones brutas
    const inversionAscensores = newImpactosTotalAscensores * cpmAscensores;
    const inversionTotems = newImpactosTotalTotems * cpmTotems;
    const inversionCowork = newImpactosTotalCowork * cpmCowork;
    const inversionEspera = newImpactosTotalEspera * cpmEspera;

    // Salidas e impactos totales
    const newSalidasTotales = newSalidasAscensores + newSalidasTotems + newSalidasCowork + newSalidasEspera;
    setSalidasTotales(newSalidasTotales);
    const newImpactosTotales =
      (newImpactosTotalAscensores || 0) +
      (newImpactosTotalTotems || 0) +
      (newImpactosTotalCowork || 0) +
      (newImpactosTotalEspera || 0);
    setImpactosTotales(newImpactosTotales);

    setSelectedMoneda(forceDollars ? "US$" : moneda(pais));

    // Descuento por duración
    let descuentoDuracion;
    if (duracion === 6) descuentoDuracion = 0.01;
    else if (duracion === 7) descuentoDuracion = 0.0115;
    else if (duracion === 8) descuentoDuracion = 0.0125;
    else if (duracion === 9) descuentoDuracion = 0.0135;
    else if (duracion === 10) descuentoDuracion = 0.0145;
    else if (duracion === 11) descuentoDuracion = 0.0155;
    else if (duracion === 12) descuentoDuracion = 0.0165;
    else if (duracion === 13) descuentoDuracion = 0.0175;
    else if (duracion === 14) descuentoDuracion = 0.0185;
    else if (duracion === 15) descuentoDuracion = 0.0195;
    else descuentoDuracion = 0;

    if (duracion > 12 && newHorasFinal > 12) {
      descuentoDuracion += descuentoDuracion * 0.1;
    }

    // Descuento por inventario
    const totalPantallasDisponibles = ascensoresTotal + totemsTotal + coworkTotal + esperaTotal;
    const totalPantallasSeleccionadas =
      ascensoresSeleccionados + totemsSeleccionados + coworkSeleccionados + esperaSeleccionados;
    let invRatio = 0;
    if (totalPantallasDisponibles > 0) {
      invRatio = totalPantallasSeleccionadas / totalPantallasDisponibles;
    }
    const descuentoMaximoInventario = 0.075;
    let descuentoInventario = invRatio * descuentoMaximoInventario;
    descuentoInventario = Math.min(descuentoInventario, descuentoMaximoInventario);
    if (invRatio < 0.5) descuentoInventario *= 0.5;
    const descuentoTotalPorInventario = descuentoInventario;

    // Descuento por plazo
    const maxDescPlazo = 0.06;
    const effectivePlazo = Math.min(plazo, 260);
    const tau = 120;
    const normPlazo = 1 - Math.exp(-260 / tau);
    let descuentoPlazo = (maxDescPlazo * (1 - Math.exp(-effectivePlazo / tau))) / normPlazo;
    if (effectivePlazo < 20) descuentoPlazo = Math.max(descuentoPlazo, 0.005);
    if (invRatio > 0.7 && effectivePlazo > 60) {
      descuentoPlazo *= 1.25;
    }

    // Descuento por frecuencia
    let descuentoFrecuenciaNuevo = 0;
    if (frecuenciaNumero === 5) {
      descuentoFrecuenciaNuevo = 0.02;
    } else if (frecuenciaNumero >= 10 && frecuenciaNumero <= 30 && frecuenciaNumero % 5 === 0) {
      const incremento = (frecuenciaNumero - 5) / 5;
      descuentoFrecuenciaNuevo = (0.02 + incremento * 0.02) * 0.9;
    }
    const descuentoFrecuenciaNuevoHoras =
      newHorasFinal === 7 ? descuentoFrecuenciaNuevo / 2.2 : descuentoFrecuenciaNuevo;

    let bonoFreqPlazo = 0;
    if (frecuenciaNumero === 5 && plazo >= 20) bonoFreqPlazo = 0.01;
    else if (frecuenciaNumero === 10 && plazo >= 10 && plazo < 20) bonoFreqPlazo = 0.015;
    else if (frecuenciaNumero === 15 && plazo >= 5 && plazo < 10) bonoFreqPlazo = 0.02;
    else if (frecuenciaNumero === 20 && plazo < 5) bonoFreqPlazo = 0.025;
    else if ((frecuenciaNumero === 25 || frecuenciaNumero === 30) && newHorasFinal < 14 && plazo < 20)
      bonoFreqPlazo = 0.03;

    let multiplicadorFreqPlazoInv = 1;
    if (bonoFreqPlazo > 0 && (effectivePlazo > 60 || invRatio > 0.7)) {
      multiplicadorFreqPlazoInv = 1.15;
    }

    let penalizacionFreqInadecuada = 1;
    if (frecuenciaNumero < 15 && effectivePlazo > 60) {
      penalizacionFreqInadecuada = 0.9;
    }

    const descuentoFrecAjustado =
      (descuentoFrecuenciaNuevoHoras + bonoFreqPlazo) * multiplicadorFreqPlazoInv * penalizacionFreqInadecuada;

    // Descuento global (sistema)
    const newDescuentoGlobal = descuentoDuracion + descuentoTotalPorInventario + descuentoPlazo + descuentoFrecAjustado;
    const cappedDescuentoGlobal = Math.min(newDescuentoGlobal, 0.2);
    setDescuentoGlobal(cappedDescuentoGlobal);

    // Inversiones finales por circuito (solo con descuento del sistema)
    const newInversionAscensoresFinal = inversionAscensores * (1 - cappedDescuentoGlobal);
    const newInversionTotemsFinal = inversionTotems * (1 - cappedDescuentoGlobal);
    const newInversionCoworkFinal = inversionCowork * (1 - cappedDescuentoGlobal);
    const newInversionEsperaFinal = inversionEspera * (1 - cappedDescuentoGlobal);

    setInversionAscensoresFinal(newInversionAscensoresFinal);
    setInversionTotemsFinal(newInversionTotemsFinal);
    setInversionCoworkFinal(newInversionCoworkFinal);
    setInversionEsperaFinal(newInversionEsperaFinal);

    // Tarifas frías (brutas)
    const newTarifaFriaAscensores = inversionAscensores;
    const newTarifaFriaTotems = inversionTotems;
    const newTarifaFriaCowork = inversionCowork;
    const newTarifaFriaEspera = inversionEspera;
    setTarifaFriaAscensores(newTarifaFriaAscensores);
    setTarifaFriaTotems(newTarifaFriaTotems);
    setTarifaFriaCowork(newTarifaFriaCowork);
    setTarifaFriaEspera(newTarifaFriaEspera);
    const newTarifaFriaTotal =
      (newTarifaFriaAscensores || 0) +
      (newTarifaFriaTotems || 0) +
      (newTarifaFriaCowork || 0) +
      (newTarifaFriaEspera || 0);
    setTarifaFriaTotal(newTarifaFriaTotal);

    // Base total (sin descuento manual)
    const baseInversionFinalTotal =
      (newInversionAscensoresFinal || 0) +
      (newInversionTotemsFinal || 0) +
      (newInversionCoworkFinal || 0) +
      (newInversionEsperaFinal || 0);
    setBaseInversionFinalTotal(baseInversionFinalTotal);

    // APLICAR DESCUENTO MANUAL SOLO AL TOTAL
    let effectiveManualDiscountAmount = 0;
    let effectiveFinalAmount = baseInversionFinalTotal;

    if (discountType === "percentage") {
      effectiveManualDiscountAmount = (discountPercentage / 100) * baseInversionFinalTotal;
    } else if (discountType === "amount") {
      effectiveManualDiscountAmount = manualDiscountAmount;
    } else if (discountType === "final") {
      effectiveFinalAmount = finalAmount;
      effectiveManualDiscountAmount = baseInversionFinalTotal - effectiveFinalAmount;
    }

    effectiveManualDiscountAmount = Math.min(effectiveManualDiscountAmount, baseInversionFinalTotal);
    effectiveFinalAmount = Math.max(0, baseInversionFinalTotal - effectiveManualDiscountAmount);

    setManualDiscountAmount(effectiveManualDiscountAmount);
    setFinalAmount(effectiveFinalAmount);
    setInversionFinalTotal(effectiveFinalAmount); // ← TOTAL FINAL CON DESCUENTO MANUAL

    // CPM por circuito (sin descuento manual)
    const newCpmAscensoresFinal =
      newImpactosTotalAscensores > 0 ? (newInversionAscensoresFinal / newImpactosTotalAscensores) * 1000 : 0;
    const newCpmTotemsFinal =
      newImpactosTotalTotems > 0 ? (newInversionTotemsFinal / newImpactosTotalTotems) * 1000 : 0;
    const newCpmCoworkFinal =
      newImpactosTotalCowork > 0 ? (newInversionCoworkFinal / newImpactosTotalCowork) * 1000 : 0;
    const newCpmEsperaFinal =
      newImpactosTotalEspera > 0 ? (newInversionEsperaFinal / newImpactosTotalEspera) * 1000 : 0;

    setCpmAscensoresFinal(newCpmAscensoresFinal);
    setCpmTotemsFinal(newCpmTotemsFinal);
    setCpmCoworkFinal(newCpmCoworkFinal);
    setCpmEsperaFinal(newCpmEsperaFinal);

    const newCpmTotalFinal = newImpactosTotales > 0 ? (effectiveFinalAmount / newImpactosTotales) * 1000 : 0;
    setCpmTotalFinal(newCpmTotalFinal);

    // Sincronizar estados
    if (discountType !== "none") {
      setOriginalAmount(baseInversionFinalTotal);
    }
    setDiscountPercentage(
      baseInversionFinalTotal > 0 ? (effectiveManualDiscountAmount / baseInversionFinalTotal) * 100 : 0
    );
  }, [
    ascensoresSeleccionados,
    totemsSeleccionados,
    coworkSeleccionados,
    esperaSeleccionados,
    audienciaSeleccionadaAscensor,
    audienciaSeleccionadaTotems,
    audienciaSeleccionadaCowork,
    audienciaSeleccionadaEspera,
    plazo,
    frecuenciaNumero,
    horasSeleccionadas,
    duracion,
    pais,
    ascensoresTotal,
    totemsTotal,
    coworkTotal,
    esperaTotal,
    forceDollars,
    forceRecalc,
    discountType,
    discountPercentage,
    manualDiscountAmount,
    finalAmount,
  ]);

  // Detectar cambios en los datos
  useEffect(() => {
    if (!isEditMode || !initialData || !isInitialized) {
      setHasChanges(false);
      setHasProposalChanges(false);
      return;
    }
    // Combinar las listas de edificios actuales y eliminar duplicados
    const edificiosActualesArray = [
      ...(inventarioData.edificiosSeleccionadosAscensores || []),
      ...(inventarioData.edificiosSeleccionadosTotems || []),
      ...(inventarioData.edificiosSeleccionadosCowork || []),
      ...(inventarioData.edificiosSeleccionadosEspera || []),
    ].filter(Boolean);
    const uniqueEdificiosActualesArray = [...new Set(edificiosActualesArray)].sort((a, b) => a - b);
    const edificiosActuales = uniqueEdificiosActualesArray.join(",");
    const edificiosInicialesArray = (initialData.edificiosparticipantes || "").split(",").filter(Boolean).map(Number);
    const uniqueEdificiosInicialesArray = [...new Set(edificiosInicialesArray)].sort((a, b) => a - b);
    const edificiosIniciales = uniqueEdificiosInicialesArray.join(",");
    const ascensoresIdsActuales = (inventarioData.edificiosSeleccionadosAscensores || [])
      .sort((a, b) => a - b)
      .join(",");
    const totemsIdsActuales = (inventarioData.edificiosSeleccionadosTotems || []).sort((a, b) => a - b).join(",");
    const esperaIdsActuales = (inventarioData.edificiosSeleccionadosEspera || []).sort((a, b) => a - b).join(",");
    const coworkIdsActuales = (inventarioData.edificiosSeleccionadosCowork || []).sort((a, b) => a - b).join(",");
    const currentData = {
      edificiosparticipantes: edificiosActuales,
      pantallas_ascensores: ascensoresIdsActuales,
      pantallas_circulacion: totemsIdsActuales,
      pantallas_espera: esperaIdsActuales,
      pantallas_cowork: coworkIdsActuales,
      periodopauta: plazo || 0,
      formatopauta: frecuencia ? String(frecuencia) : "15",
      horas_pauta: horasSeleccionadas.horas || 14,
      intervalos: horasSeleccionadas.intervalos || [],
      options: horasSeleccionadas.options || [{ label: "FULL DAY | 07:00 - 21:00", hours: 14 }],
      duracion: duracion || 10,
      tipo: isProgrammaticSelected ? "p" : "d",
      mes_cierre: updateFormValues.mes_cierre || initialData.mes_cierre,
      mes_factura: updateFormValues.mes_factura || initialData.mes_factura,
      estatus: updateFormValues.estatus || initialData.estatus,
      importe: Math.floor(inversionFinalTotal || 0),
    };
    const differences = {};
    const proposalDifferences = {};
    // Comparar campos de la propuesta
    if (edificiosActuales !== edificiosIniciales) {
      differences.edificiosparticipantes = {
        current: edificiosActuales,
        initial: edificiosIniciales,
      };
      proposalDifferences.edificiosparticipantes = differences.edificiosparticipantes;
    }
    if (currentData.pantallas_ascensores !== initialData.pantallas_ascensores) {
      differences.pantallas_ascensores = {
        current: currentData.pantallas_ascensores,
        initial: initialData.pantallas_ascensores,
      };
      proposalDifferences.pantallas_ascensores = differences.pantallas_ascensores;
    }
    if (currentData.pantallas_circulacion !== initialData.pantallas_circulacion) {
      differences.pantallas_circulacion = {
        current: currentData.pantallas_circulacion,
        initial: initialData.pantallas_circulacion,
      };
      proposalDifferences.pantallas_circulacion = differences.pantallas_circulacion;
    }
    if (currentData.pantallas_espera !== initialData.pantallas_espera) {
      differences.pantallas_espera = {
        current: currentData.pantallas_espera,
        initial: initialData.pantallas_espera,
      };
      proposalDifferences.pantallas_espera = differences.pantallas_espera;
    }
    if (currentData.pantallas_cowork !== initialData.pantallas_cowork) {
      differences.pantallas_cowork = {
        current: currentData.pantallas_cowork,
        initial: initialData.pantallas_cowork,
      };
      proposalDifferences.pantallas_cowork = differences.pantallas_cowork;
    }
    if (currentData.periodopauta !== initialData.periodopauta) {
      differences.periodopauta = {
        current: currentData.periodopauta,
        initial: initialData.periodopauta,
      };
      proposalDifferences.periodopauta = differences.periodopauta;
    }
    if (currentData.formatopauta !== initialData.formatopauta) {
      differences.formatopauta = {
        current: currentData.formatopauta,
        initial: initialData.formatopauta,
      };
      proposalDifferences.formatopauta = differences.formatopauta;
    }
    if (currentData.horas_pauta !== initialData.horas_pauta) {
      differences.horas_pauta = {
        current: currentData.horas_pauta,
        initial: initialData.horas_pauta,
      };
      proposalDifferences.horas_pauta = differences.horas_pauta;
    }
    if (JSON.stringify(currentData.intervalos) !== JSON.stringify(initialData.intervalos)) {
      differences.intervalos = {
        current: currentData.intervalos,
        initial: initialData.intervalos,
      };
      proposalDifferences.intervalos = differences.intervalos;
    }
    if (JSON.stringify(currentData.options) !== JSON.stringify(initialData.options)) {
      differences.options = {
        current: currentData.options,
        initial: initialData.options,
      };
      proposalDifferences.options = differences.options;
    }
    if (currentData.duracion !== initialData.duracion) {
      differences.duracion = {
        current: currentData.duracion,
        initial: initialData.duracion,
      };
      proposalDifferences.duracion = differences.duracion;
    }
    if (currentData.tipo !== initialData.tipo) {
      differences.tipo = {
        current: currentData.tipo,
        initial: initialData.tipo,
      };
      proposalDifferences.tipo = differences.tipo;
    }
    // Comparar campos del formulario (no afectan la propuesta)
    if (currentData.mes_cierre !== initialData.mes_cierre) {
      differences.mes_cierre = {
        current: currentData.mes_cierre,
        initial: initialData.mes_cierre,
      };
    }
    if (currentData.mes_factura !== initialData.mes) {
      differences.mes_factura = {
        current: currentData.mes_factura,
        initial: initialData.mes,
      };
    }
    if (currentData.estatus !== initialData.estatus) {
      differences.estatus = {
        current: currentData.estatus,
        initial: initialData.estatus,
      };
    }
    // Nueva comparación agregada para importe (solo en differences, no en proposalDifferences)
    if (Math.abs(Math.floor(currentData.importe) - Math.floor(initialData.importe)) > 0) {
      differences.importe = {
        current: currentData.importe,
        initial: initialData.importe,
      };
    }
    const hasDataChanged = Object.keys(differences).length > 0;
    const hasProposalDataChanged = Object.keys(proposalDifferences).length > 0;
    setHasChanges(hasDataChanged);
    setHasProposalChanges(hasProposalDataChanged);
  }, [
    inventarioData,
    plazo,
    frecuencia,
    horasSeleccionadas,
    duracion,
    isProgrammaticSelected,
    updateFormValues,
    initialData,
    isInitialized,
    isEditMode,
    inversionFinalTotal,
  ]);

  useEffect(() => {
    const initialize = async () => {
      try {
        const newEdificios = await getEdificios({ pais });
        const hasInstallation = newEdificios.some(
          (edificio) => edificio.estado === "INSTALACIÓN" || edificio.estado === "REACTIVACIÓN"
        );
        setHasInstallingBuildings(hasInstallation);
        newEdificios.sort((a, b) => a.edificio.localeCompare(b.edificio));
        setEdificios(newEdificios); // Asegura que edificios esté poblado
        // Filtrado de edificios para totales
        const edificiosParaTotales = includeInstallingBuildings
          ? newEdificios // Incluye todos, incluyendo REACTIVACIÓN
          : newEdificios.filter((edificio) => edificio.estado === "OPERATIVO");
        // Calcular totales solo con edificiosParaTotales
        const totalAscensores = edificiosParaTotales.reduce((sum, edificio) => sum + (edificio.pantallas || 0), 0);
        const totalTotems = edificiosParaTotales.reduce((sum, edificio) => sum + (edificio.totems || 0), 0);
        const totalCowork = edificiosParaTotales.reduce((sum, edificio) => sum + (edificio.cowork || 0), 0);
        const totalEspera = edificiosParaTotales.reduce((sum, edificio) => sum + (edificio.espera || 0), 0);
        setAscensoresTotal(totalAscensores);
        setTotemsTotal(totalTotems);
        setCoworkTotal(totalCowork);
        setEsperaTotal(totalEspera);
        // Mapear nombres de edificios seleccionados usando TODOS los edificios (newEdificios)
        const ascensoresIds = Array.isArray(inventarioData.edificiosSeleccionadosAscensores)
          ? inventarioData.edificiosSeleccionadosAscensores.map((id) => Number(id))
          : [];
        const totemsIds = Array.isArray(inventarioData.edificiosSeleccionadosTotems)
          ? inventarioData.edificiosSeleccionadosTotems.map((id) => Number(id))
          : [];
        const coworkIds = Array.isArray(inventarioData.edificiosSeleccionadosCowork)
          ? inventarioData.edificiosSeleccionadosCowork.map((id) => Number(id))
          : [];
        const esperaIds = Array.isArray(inventarioData.edificiosSeleccionadosEspera)
          ? inventarioData.edificiosSeleccionadosEspera.map((id) => Number(id))
          : [];
        const nombresEdificiosSeleccionadosAscensores = newEdificios
          .filter((edificio) => ascensoresIds.includes(edificio.id))
          .map((edificio) => edificio.edificio);
        const nombresEdificiosSeleccionadosTotems = newEdificios
          .filter((edificio) => totemsIds.includes(edificio.id))
          .map((edificio) => edificio.edificio);
        const nombresEdificiosSeleccionadosCowork = newEdificios
          .filter((edificio) => coworkIds.includes(edificio.id))
          .map((edificio) => edificio.edificio);
        const nombresEdificiosSeleccionadosEspera = newEdificios
          .filter((edificio) => esperaIds.includes(edificio.id))
          .map((edificio) => edificio.edificio);
        const nombresEdificiosNoSeleccionados = newEdificios
          .filter((edificio) => {
            const isSelected =
              ascensoresIds.includes(edificio.id) ||
              totemsIds.includes(edificio.id) ||
              coworkIds.includes(edificio.id) ||
              esperaIds.includes(edificio.id);
            return !isSelected && edificio.estado !== "STANDBY";
          })
          .map((edificio) => edificio.edificio);
        setNombresEdificiosSeleccionadosAscensores(nombresEdificiosSeleccionadosAscensores);
        setNombresEdificiosSeleccionadosTotems(nombresEdificiosSeleccionadosTotems);
        setNombresEdificiosSeleccionadosCowork(nombresEdificiosSeleccionadosCowork);
        setNombresEdificiosSeleccionadosEspera(nombresEdificiosSeleccionadosEspera);
        setNombresEdificiosNoSeleccionados(nombresEdificiosNoSeleccionados);
      } catch (error) {
        if (process.env.NODE_ENV !== "production") {
          console.error("Error al obtener edificios:", error);
        }
      }
    };
    initialize();
  }, [pais, inventarioData, includeInstallingBuildings]);

  useEffect(() => {
    setFinalAmountStr(finalAmount.toString());
    setManualDiscountAmountStr(manualDiscountAmount.toString());
    setDiscountPercentageStr(discountPercentage.toString());
  }, [finalAmount, manualDiscountAmount, discountPercentage]);

  const todosLosTotalesCompletos = () =>
    edificiosUnicosTotal > 0 &&
    ascensoresSeleccionados + totemsSeleccionados + coworkSeleccionados + esperaSeleccionados > 0 &&
    audienciaSeleccionadaTotal > 0 &&
    horasFinal > 0 &&
    plazo > 0 &&
    salidasTotales > 0 &&
    impactosTotales > 0 &&
    duracion > 0 &&
    tarifaFriaTotal > 0 &&
    inversionFinalTotal > 0 &&
    cpmTotalFinal;

  const usuarioNombre = nombre || "usuario";
  const usuarioApellido = apellido || "usuario";

  const codigoGenerado = isEditMode ? opportunityData?.code : generarCodigoAleatorio();

  const buildOportunidadData = (
    data,
    selectedClient,
    userId,
    isProgrammaticSelected,
    inventarioData,
    inversionFinalTotal,
    edificiosUnicosTotal,
    ascensoresSeleccionados,
    totemsSeleccionados,
    coworkSeleccionados,
    esperaSeleccionados,
    frecuencia,
    plazo,
    duracion,
    pais,
    horasSeleccionadas,
    codigoGenerado,
    opportunityData = null,
    updatedAt = null,
    clientes
  ) => {
    const clientId = selectedClient
      ? clientes.find((cliente) => cliente.nombre === selectedClient.nombre)?.id || null
      : null;
    const edificiosparticipantesIdsArray = [
      ...(inventarioData.edificiosSeleccionadosAscensores || []),
      ...(inventarioData.edificiosSeleccionadosTotems || []),
      ...(inventarioData.edificiosSeleccionadosCowork || []),
      ...(inventarioData.edificiosSeleccionadosEspera || []),
    ].filter(Boolean);
    const uniqueEdificiosparticipantesIds = [...new Set(edificiosparticipantesIdsArray)].join(",");
    const ascensoresIds = (inventarioData.edificiosSeleccionadosAscensores || []).join(",");
    const circulacionIds = (inventarioData.edificiosSeleccionadosTotems || []).join(",");
    const esperaIds = (inventarioData.edificiosSeleccionadosEspera || []).join(",");
    const coworkIds = (inventarioData.edificiosSeleccionadosCowork || []).join(",");
    const currentVersion = opportunityData?.version ? parseInt(opportunityData.version, 10) : 0;
    const newVersion = updatedAt ? currentVersion + 1 : 1;
    const hasManualDiscount = manualDiscountAmount > 0;
    const finalImporte = hasManualDiscount ? Math.floor(finalAmount) : Math.floor(inversionFinalTotal);

    // Ajustar formatMonthYear para MM-YYYY
    const formatMonthYear = (month, year) => {
      if (!month || !year || isNaN(parseInt(month, 10)) || isNaN(parseInt(year, 10))) {
        return null;
      }
      return `${month.padStart(2, "0")}-${year}`; // MM-YYYY
    };

    const oportunidadData = {
      cliente: data.clientePublicitario || opportunityData?.cliente || "Sin cliente",
      client_id: clientId,
      campana: data.campana || opportunityData?.campana || null,
      canal: data.canal || opportunityData?.canal || null,
      mes_factura: formatMonthYear(data.mes_factura, data.ano_factura) || opportunityData?.mes || null,
      mes_cierre: formatMonthYear(data.mes_cierre, data.ano_cierre) || opportunityData?.mes_cierre || null,
      ano: parseInt(data.ano_factura || new Date().getFullYear().toString(), 10), // Usar ano_factura como base
      importe: finalImporte,
      estatus: data.estatus || opportunityData?.estatus || "0%",
      ejecutivo: userId ? parseInt(userId, 10) : null,
      tipo: isProgrammaticSelected ? "p" : "d",
      edificiosparticipantes: uniqueEdificiosparticipantesIds || "",
      edificiostotales: edificiosUnicosTotal || 0,
      pantallastotales:
        (ascensoresSeleccionados || 0) +
        (totemsSeleccionados || 0) +
        (coworkSeleccionados || 0) +
        (esperaSeleccionados || 0),
      pantallas_ascensores: ascensoresIds || "",
      pantallas_circulacion: circulacionIds || "",
      pantallas_espera: esperaIds || "",
      pantallas_cowork: coworkIds || "",
      formatopauta: frecuencia?.toString() || "0",
      periodopauta: plazo || 0,
      duracion: duracion || 0,
      pais: pais || "Chile",
      facturafecha: opportunityData?.facturafecha || null,
      plazocobro: opportunityData?.plazocobro || null,
      facturafechacobro: opportunityData?.facturafechacobro || null,
      facturanumero: opportunityData?.facturanumero || null,
      eliminada: false,
      code: updatedAt && opportunityData?.code ? opportunityData.code : codigoGenerado,
      comision_agencia: opportunityData?.comision_agencia || null,
      horas_pauta: horasSeleccionadas.horas || 0,
      intervalos: horasSeleccionadas.intervalos ? JSON.stringify(horasSeleccionadas.intervalos) : null,
      options: horasSeleccionadas.options ? JSON.stringify(horasSeleccionadas.options) : null,
      moneda_dolar: forceDollars,
      version: newVersion,
      has_manual_discount: hasManualDiscount,
      manual_discount_amount: hasManualDiscount ? Math.floor(manualDiscountAmount) : null,
      original_amount: hasManualDiscount ? Math.floor(inversionFinalTotal) : null,
    };
    if (updatedAt) {
      oportunidadData.updated_at = updatedAt;
    }
    return oportunidadData;
  };

  const handleLinkOportunidad = async (data) => {
    if (isSubmitting) {
      return; // Ignore clicks while in cooldown
    }

    setIsSubmitting(true); // Start cooldown

    try {
      if (!data.clientePublicitario) {
        toast.error("Por favor, selecciona un cliente publicitario.");
        setIsSubmitting(false); // Reset cooldown on error
        return;
      }

      const selectedClient = clientes.find((cliente) => cliente.nombre === data.clientePublicitario);

      if (!selectedClient) {
        toast.error("Cliente no encontrado. Por favor, selecciona un cliente válido.");
        setIsSubmitting(false); // Reset cooldown on error
        return;
      }

      const oportunidadData = buildOportunidadData(
        data,
        selectedClient,
        userId,
        isProgrammaticSelected,
        inventarioData,
        inversionFinalTotal,
        edificiosUnicosTotal,
        ascensoresSeleccionados,
        totemsSeleccionados,
        coworkSeleccionados,
        esperaSeleccionados,
        frecuencia,
        plazo,
        duracion,
        pais,
        horasSeleccionadas,
        codigoGenerado,
        null,
        null,
        clientes
      );

      await saveOportunidad(oportunidadData);

      // Update clientes table with contact information
      const today = new Date();
      const nextContactDate = new Date(today);
      nextContactDate.setDate(today.getDate() + 7);

      const formatDate = (date) => date.toISOString().split("T")[0]; // Format as YYYY-MM-DD

      const updatedData = {
        id: selectedClient.id,
      };

      if (data.tipoCotizacion === "cliente") {
        updatedData.ultimo_contacto_fecha_cliente = formatDate(today);
        updatedData.ultimo_contacto_accion_cliente = "QUOTE";
        updatedData.proximo_contacto_fecha_cliente = formatDate(nextContactDate);
        updatedData.proximo_contacto_accion_cliente = "FOLLOW UP";
      } else if (data.tipoCotizacion === "agencia") {
        updatedData.ultimo_contacto_fecha_agencia = formatDate(today);
        updatedData.ultimo_contacto_accion_agencia = "QUOTE";
        updatedData.proximo_contacto_fecha_agencia = formatDate(nextContactDate);
        updatedData.proximo_contacto_accion_agencia = "FOLLOW UP";
      }

      try {
        await updateCliente(updatedData);
      } catch (error) {
        console.error("Error updating cliente contact info:", error);
        toast.error(
          "Error al actualizar información de contacto del cliente, pero la oportunidad se vinculó correctamente."
        );
      }

      setClienteParaDescarga(data.clientePublicitario);
      setShowLinkModal(false);
      toast.success("Oportunidad vinculada correctamente");

      try {
        const pdfDoc = generatePdfDocument();
        const blob = await pdf(pdfDoc).toBlob();
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = generateFileName(data.clientePublicitario, data.campana, true);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (pdfError) {
        console.error("Error al generar el PDF:", pdfError);
        toast.error("Error al generar el PDF, pero la oportunidad se vinculó correctamente.");
      }
    } catch (error) {
      console.error("Error en handleLinkOportunidad:", error);
      toast.error(`Error al vincular oportunidad: ${error.message}`);
    } finally {
      // Reset the cooldown after 1 second
      setTimeout(() => {
        setIsSubmitting(false);
      }, 1000);
    }
  };

  const currentOpportunityId = parseInt(opportunityId, 10); // Convertir a entero

  const handleUpdateOportunidad = useCallback(
    async (formData) => {
      if (!validateData()) {
        toast.error("Por favor, valida los datos antes de actualizar.");
        return;
      }
      if (!currentOpportunityId || isNaN(currentOpportunityId)) {
        toast.error("ID de oportunidad no válido o no proporcionado");
        console.error("Invalid currentOpportunityId:", currentOpportunityId);
        setLoading(false);
        return;
      }
      // Validación de fechas
      const cierreFull = new Date(`${formData.ano_cierre}-${formData.mes_cierre.padStart(2, "0")}-01`);
      const facturaFull = new Date(`${formData.ano_factura}-${formData.mes_factura.padStart(2, "0")}-01`);
      if (isNaN(cierreFull.getTime()) || isNaN(facturaFull.getTime())) {
        toast.error("Fechas inválidas");
        setLoading(false);
        return;
      }
      if (cierreFull > facturaFull) {
        toast.error("Fecha de cierre no puede ser posterior a fecha de factura");
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const selectedClient = clientes.find((cliente) => cliente.nombre === opportunityData?.cliente);
        const oportunidadData = buildOportunidadData(
          formData,
          selectedClient,
          userId,
          isProgrammaticSelected,
          inventarioData,
          inversionFinalTotal,
          edificiosUnicosTotal,
          ascensoresSeleccionados,
          totemsSeleccionados,
          coworkSeleccionados,
          esperaSeleccionados,
          frecuencia,
          plazo,
          duracion,
          pais,
          horasSeleccionadas,
          codigoGenerado,
          opportunityData,
          new Date().toISOString(),
          clientes
        );
        console.log("Opportunity data being sent:", oportunidadData);
        await updateOportunidad({ id: currentOpportunityId, oportunidad: oportunidadData });
        const proposalChanged = calculateProposalChanges();
        if (proposalChanged) {
          try {
            const pdfDoc = generatePdfDocument();
            const blob = await pdf(pdfDoc).toBlob();
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = generateFileName();
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
          } catch (pdfError) {
            console.error("Error al generar el PDF:", pdfError);
            toast.error("Error al generar el PDF, pero la oportunidad se actualizó correctamente.");
          }
        }
        toast.success("Oportunidad actualizada correctamente");
        // Redirigir a la página precedente
        navigate(-1);
      } catch (error) {
        console.error("Error al actualizar oportunidad:", error);
        toast.error(error.message || "Error al actualizar la oportunidad");
      } finally {
        setLoading(false);
      }
    },
    [
      validateData,
      inventarioData,
      clientes,
      opportunityData,
      userId,
      isProgrammaticSelected,
      edificiosUnicosTotal,
      frecuencia,
      plazo,
      duracion,
      pais,
      horasSeleccionadas,
      inversionFinalTotal,
      navigate,
      codigoGenerado,
      calculateProposalChanges,
    ]
  );

  const generatePdfDocument = () => (
    <PdfCotizacion
      nombresEdificiosSeleccionadosAscensores={nombresEdificiosSeleccionadosAscensores}
      nombresEdificiosSeleccionadosTotems={nombresEdificiosSeleccionadosTotems}
      nombresEdificiosSeleccionadosCowork={nombresEdificiosSeleccionadosCowork}
      nombresEdificiosSeleccionadosEspera={nombresEdificiosSeleccionadosEspera}
      nombresEdificiosNoSeleccionados={nombresEdificiosNoSeleccionados}
      edificiosUnicosTotal={edificiosUnicosTotal}
      ascensoresSeleccionados={ascensoresSeleccionados}
      totemsSeleccionados={totemsSeleccionados}
      coworkSeleccionados={coworkSeleccionados}
      esperaSeleccionados={esperaSeleccionados}
      audienciaSeleccionadaTotal={audienciaSeleccionadaTotal}
      audienciaSeleccionadaAscensor={audienciaSeleccionadaAscensor}
      audienciaSeleccionadaTotems={audienciaSeleccionadaTotems}
      audienciaSeleccionadaCowork={audienciaSeleccionadaCowork}
      audienciaSeleccionadaEspera={audienciaSeleccionadaEspera}
      horasFinal={horasFinal}
      plazo={plazo}
      salidasTotales={salidasTotales}
      salidasAscensores={salidasAscensores}
      salidasTotems={salidasTotems}
      salidasCowork={salidasCowork}
      salidasEspera={salidasEspera}
      impactosTotales={impactosTotales}
      impactosTotalAscensores={impactosTotalAscensores}
      impactosTotalTotems={impactosTotalTotems}
      impactosTotalCowork={impactosTotalCowork}
      impactosTotalEspera={impactosTotalEspera}
      duracion={duracion}
      tarifaFriaTotal={tarifaFriaTotal}
      tarifaFriaAscensores={tarifaFriaAscensores}
      tarifaFriaTotems={tarifaFriaTotems}
      tarifaFriaCowork={tarifaFriaCowork}
      tarifaFriaEspera={tarifaFriaEspera}
      descuentoGlobal={descuentoGlobal}
      inversionFinalTotal={inversionFinalTotal}
      inversionAscensoresFinal={inversionAscensoresFinal}
      inversionTotemsFinal={inversionTotemsFinal}
      inversionCoworkFinal={inversionCoworkFinal}
      inversionEsperaFinal={inversionEsperaFinal}
      cpmTotalFinal={cpmTotalFinal}
      cpmAscensoresFinal={cpmAscensoresFinal}
      cpmTotemsFinal={cpmTotemsFinal}
      cpmCoworkFinal={cpmCoworkFinal}
      cpmEsperaFinal={cpmEsperaFinal}
      selectedMoneda={selectedMoneda}
      logo={logo}
      pais={pais}
      cliente={clienteParaDescarga || cliente}
      fecha={obtenerFechaActual()}
      usuario={`${usuarioNombre} ${usuarioApellido}`}
      operacion={operacionTextual(pais)}
      isProgrammaticSelected={isProgrammaticSelected}
      intervalos={horasSeleccionadas?.intervalos || []}
      options={horasSeleccionadas?.options || []}
      usuarioNombre={usuarioNombre}
      usuarioApellido={usuarioApellido}
      frecuencia={frecuencia}
      codigoGenerado={codigoGenerado}
      includeInstallingBuildings={includeInstallingBuildings}
      manualDiscountAmount={manualDiscountAmount}
      finalAmount={finalAmount}
      manualDiscountPercentage={manualDiscountPercentage}
    />
  );

  const pdfDocument = useMemo(
    () => generatePdfDocument(),
    [
      nombresEdificiosSeleccionadosAscensores,
      nombresEdificiosSeleccionadosTotems,
      nombresEdificiosSeleccionadosCowork,
      nombresEdificiosSeleccionadosEspera,
      nombresEdificiosNoSeleccionados,
      edificiosUnicosTotal,
      ascensoresSeleccionados,
      totemsSeleccionados,
      coworkSeleccionados,
      esperaSeleccionados,
      audienciaSeleccionadaTotal,
      audienciaSeleccionadaAscensor,
      audienciaSeleccionadaTotems,
      audienciaSeleccionadaCowork,
      audienciaSeleccionadaEspera,
      horasFinal,
      plazo,
      salidasTotales,
      salidasAscensores,
      salidasTotems,
      salidasCowork,
      salidasEspera,
      impactosTotales,
      impactosTotalAscensores,
      impactosTotalTotems,
      impactosTotalCowork,
      impactosTotalEspera,
      duracion,
      tarifaFriaTotal,
      tarifaFriaAscensores,
      tarifaFriaTotems,
      tarifaFriaCowork,
      tarifaFriaEspera,
      descuentoGlobal,
      inversionFinalTotal,
      inversionAscensoresFinal,
      inversionTotemsFinal,
      inversionCoworkFinal,
      inversionEsperaFinal,
      cpmTotalFinal,
      cpmAscensoresFinal,
      cpmTotemsFinal,
      cpmCoworkFinal,
      cpmEsperaFinal,
      selectedMoneda,
      logo,
      pais,
      clienteParaDescarga,
      cliente,
      usuarioNombre,
      usuarioApellido,
      operacionTextual,
      isProgrammaticSelected,
      horasSeleccionadas?.intervalos,
      horasSeleccionadas?.options,
      frecuencia,
      codigoGenerado,
      includeInstallingBuildings,
    ]
  );

  const canLinkOpportunity = ["comercial", "gerencia", "superadmin"].includes(rol);

  if (session === undefined) return <Loader fullPage />;

  const handleCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    setIncludeInstallingBuildings(isChecked);
    if (onIncludeInstallingBuildingsChange) {
      onIncludeInstallingBuildingsChange(isChecked);
    }
  };

  // Nueva función generateFileName
  const generateFileName = (client = null, campana = null, isForLink = false) => {
    const fecha = obtenerFechaActual();
    const operacion = operacionTextual(pais);
    const codigo = cotizacionCode || codigoGenerado;

    let baseFileName;
    if (isEditMode) {
      // En modo edición, incluir cliente y campaña de opportunityData
      const version = opportunityData?.version ? parseInt(opportunityData.version, 10) + 1 : 1;
      baseFileName = `${fecha}. ${operacion} - Cotización ${codigo} - ${sanitizeFileName(cliente || "Sin Cliente")} - ${sanitizeFileName(opportunityData?.campana || "Sin Campaña")} - versión ${version}.pdf`;
    } else if (isForLink && client && campana) {
      // Para "Vincular cliente", incluir cliente y campaña
      baseFileName = `${fecha}. ${operacion} - Cotización ${codigo} - ${sanitizeFileName(client)} - ${sanitizeFileName(campana)}.pdf`;
    } else {
      // Para "Generar PDF" o cualquier otro caso, usar formato simple
      baseFileName = `${fecha}. ${operacion} - Cotización ${codigo}.pdf`;
    }

    return baseFileName;
  };

  return (
    <div className="table-container-a">
      <div>
        {isEditMode ? (
          <h2 className="mb-2">
            <strong>{cliente}</strong> | #{cotizacionCode}
          </h2>
        ) : (
          <div className="logo-container mb-2">
            <img src={logo} alt="Logo" className="logo" onClick={() => navigate("/admin")} />
          </div>
        )}
      </div>
      <div className="d-flex align-items-center justify-content-center mb-2">
        <div className="checkbox-container me-4">
          <input
            type="checkbox"
            id="forceDollars"
            checked={forceDollars}
            onChange={(e) => setForceDollars(e.target.checked)}
          />
          <label htmlFor="forceDollars" className="ms-2">
            COTIZAR EN DÓLARES
          </label>
        </div>
        {hasInstallingBuildings && (
          <div className="checkbox-container">
            <input
              type="checkbox"
              id="includeInstallingBuildings"
              checked={includeInstallingBuildings}
              onChange={handleCheckboxChange}
            />
            <label htmlFor="includeInstallingBuildings" className="ms-2">
              INCLUIR EDIFICIOS EN PROCESO DE INSTALACIÓN
            </label>
          </div>
        )}
      </div>
      {isEditMode && (
        <div className="edit-form-container">
          <form onSubmit={handleSubmitUpdate(handleUpdateOportunidad)} className="mt-2">
            <div
              className="d-flex align-items-center justify-content-center mb-2"
              style={{ maxWidth: "500px", margin: "0 auto" }}
            >
              <div className="d-flex align-items-center">
                <label htmlFor="mes_cierre" style={{ width: "150px", fontSize: "1rem" }}>
                  Mes de cierre:
                </label>
                <select
                  className={`form-select ${updateErrors.mes_cierre ? "is-invalid" : ""}`}
                  style={{ width: "120px", fontSize: "1rem", padding: "0.25rem" }}
                  {...registerUpdate("mes_cierre", {
                    required: "Debes seleccionar un mes de cierre",
                  })}
                >
                  <option value="">Selecciona un mes...</option>
                  {orderedMeses.map((mes) => (
                    <option key={mes.value} value={mes.value}>
                      {mes.label}
                    </option>
                  ))}
                </select>
                {updateErrors.mes_cierre && <div className="invalid-feedback">{updateErrors.mes_cierre.message}</div>}
              </div>
              <div className="ms-4 me-4" style={{ fontSize: "1.5rem" }}>
                |
              </div>
              <div className="d-flex align-items-center">
                <label htmlFor="ano_cierre" style={{ width: "150px", fontSize: "1rem" }}>
                  Año de cierre:
                </label>
                <select
                  className={`form-select ${updateErrors.ano_cierre ? "is-invalid" : ""}`}
                  style={{ width: "120px", fontSize: "1rem", padding: "0.25rem" }}
                  {...registerUpdate("ano_cierre", { required: "Debes seleccionar un año de cierre" })}
                >
                  <option value="">Selecciona un año...</option>
                  <option value="2025">2025</option>
                  <option value="2026">2026</option>
                  <option value="2027">2027</option>
                </select>
                {updateErrors.ano_cierre && <div className="invalid-feedback">{updateErrors.ano_cierre.message}</div>}
              </div>
              <div className="ms-4 me-4" style={{ fontSize: "1.5rem" }}>
                |
              </div>
              <div className="d-flex align-items-center">
                <label htmlFor="mes_factura" style={{ width: "150px", fontSize: "1rem" }}>
                  Mes de factura:
                </label>
                <select
                  className={`form-select ${updateErrors.mes_factura ? "is-invalid" : ""}`}
                  style={{ width: "120px", fontSize: "1rem", padding: "0.25rem" }}
                  {...registerUpdate("mes_factura", {
                    required: "Debes seleccionar un mes de factura",
                  })}
                >
                  <option value="">Selecciona un mes...</option>
                  {orderedMeses.map((mes) => (
                    <option key={mes.value} value={mes.value}>
                      {mes.label}
                    </option>
                  ))}
                </select>
                {updateErrors.mes_factura && <div className="invalid-feedback">{updateErrors.mes_factura.message}</div>}
              </div>
              <div className="ms-4 me-4" style={{ fontSize: "1.5rem" }}>
                |
              </div>
              <div className="d-flex align-items-center">
                <label htmlFor="ano_factura" style={{ width: "150px", fontSize: "1rem" }}>
                  Año de factura:
                </label>
                <select
                  className={`form-select ${updateErrors.ano_factura ? "is-invalid" : ""}`}
                  style={{ width: "120px", fontSize: "1rem", padding: "0.25rem" }}
                  {...registerUpdate("ano_factura", { required: "Debes seleccionar un año de factura" })}
                >
                  <option value="">Selecciona un año...</option>
                  <option value="2025">2025</option>
                  <option value="2026">2026</option>
                  <option value="2027">2027</option>
                </select>
                {updateErrors.ano_factura && <div className="invalid-feedback">{updateErrors.ano_factura.message}</div>}
              </div>
              <div className="ms-4 mb-0" style={{ fontSize: "1.5rem" }}>
                |
              </div>
              <div className="d-flex align-items-center">
                <label htmlFor="estatus" style={{ width: "200px", fontSize: "1rem" }}>
                  Status de la propuesta:
                </label>
                <select
                  className={`form-select ${updateErrors.estatus ? "is-invalid" : ""}`}
                  style={{ width: "90px", fontSize: "0.9rem", padding: "0.25rem" }}
                  {...registerUpdate("estatus")}
                >
                  <option value="0%">0%</option>
                  <option value="50%">50%</option>
                  <option value="75%">75%</option>
                  <option value="90%">90%</option>
                  <option value="100%">100%</option>
                </select>
                {updateErrors.estatus && <div className="invalid-feedback">{updateErrors.estatus.message}</div>}
              </div>
            </div>
          </form>
        </div>
      )}
      <table className="table table-striped table-hover">
        <thead>
          <tr>
            <th>CIRCUITO</th>
            <th>EDIFICIOS</th>
            <th>PANTALLAS</th>
            <th>AUDIENCIA</th>
            <th>HORAS ON</th>
            <th>PLAZO (días)</th>
            <th>IMPRESIONES</th>
            <th>IMPACTOS</th>
            <th>
              DURACIÓN <br />
              (segundos)
            </th>
            <th>COTIZACIÓN</th>
            <th className="bg-danger">DESCUENTO</th>
            <th className="bg-success">INVERSIÓN</th>
            <th className="bg-primary">CPM</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row" className="text-start">
              ASCENSORES
            </th>
            <td>{ascensoresSeleccionados ? edificiosSeleccionadosAscensores : "-"}</td>
            <td>{ascensoresSeleccionados ? ascensoresSeleccionados : "-"}</td>
            <td>
              {ascensoresSeleccionados
                ? audienciaSeleccionadaAscensor.toLocaleString(localString(pais), {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  })
                : "-"}
            </td>
            <td>
              {ascensoresSeleccionados && horasFinal
                ? horasFinal.toLocaleString(localString(pais), { minimumFractionDigits: 1, maximumFractionDigits: 1 })
                : "-"}
            </td>
            <td>{ascensoresSeleccionados && plazo ? plazo : "-"}</td>
            <td>
              {salidasAscensores
                ? salidasAscensores.toLocaleString(localString(pais), {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  })
                : "-"}
            </td>
            <td>
              {impactosTotalAscensores
                ? impactosTotalAscensores.toLocaleString(localString(pais), {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  })
                : "-"}
            </td>
            <td>{ascensoresSeleccionados && duracion ? duracion : "-"}</td>
            <td className="text-center">
              {tarifaFriaAscensores
                ? `${selectedMoneda} ${tarifaFriaAscensores.toLocaleString(localString(pais), {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  })}`
                : "-"}
            </td>
            <td className="text-center">
              {inversionAscensoresFinal
                ? descuentoGlobal && todosLosTotalesCompletos()
                  ? `${(descuentoGlobal * 100).toLocaleString(localString(pais), {
                      minimumFractionDigits: 1,
                      maximumFractionDigits: 1,
                    })}%`
                  : "-"
                : "-"}
            </td>
            <td className="text-center">
              {inversionAscensoresFinal
                ? `${selectedMoneda} ${inversionAscensoresFinal.toLocaleString(localString(pais), {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  })}`
                : "-"}
            </td>
            <td className="text-center">
              {cpmAscensoresFinal
                ? `${selectedMoneda} ${cpmAscensoresFinal.toLocaleString(localString(pais), {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  })}`
                : "-"}
            </td>
          </tr>
          {totemsTotal > 0 && (
            <tr>
              <th scope="row" className="text-start">
                CIRCULACIÓN
              </th>
              <td>{totemsSeleccionados ? edificiosSeleccionadosTotems : "-"}</td>
              <td>{totemsSeleccionados ? totemsSeleccionados : "-"}</td>
              <td>
                {totemsSeleccionados
                  ? audienciaSeleccionadaTotems.toLocaleString(localString(pais), {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    })
                  : "-"}
              </td>
              <td>
                {totemsSeleccionados && horasFinal
                  ? horasFinal.toLocaleString(localString(pais), {
                      minimumFractionDigits: 1,
                      maximumFractionDigits: 1,
                    })
                  : "-"}
              </td>
              <td>{totemsSeleccionados && plazo ? plazo : "-"}</td>
              <td>
                {salidasTotems
                  ? salidasTotems.toLocaleString(localString(pais), {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    })
                  : "-"}
              </td>
              <td>
                {impactosTotalTotems
                  ? impactosTotalTotems.toLocaleString(localString(pais), {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    })
                  : "-"}
              </td>
              <td>{totemsSeleccionados && duracion ? duracion : "-"}</td>
              <td className="text-center">
                {tarifaFriaTotems
                  ? `${selectedMoneda} ${tarifaFriaTotems.toLocaleString(localString(pais), {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    })}`
                  : "-"}
              </td>
              <td className="text-center">
                {inversionTotemsFinal
                  ? descuentoGlobal && todosLosTotalesCompletos()
                    ? `${(descuentoGlobal * 100).toLocaleString(localString(pais), {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                      })}%`
                    : "-"
                  : "-"}
              </td>
              <td className="text-center">
                {inversionTotemsFinal
                  ? `${selectedMoneda} ${inversionTotemsFinal.toLocaleString(localString(pais), {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    })}`
                  : "-"}
              </td>
              <td className="text-center">
                {cpmTotemsFinal
                  ? `${selectedMoneda} ${cpmTotemsFinal.toLocaleString(localString(pais), {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    })}`
                  : "-"}
              </td>
            </tr>
          )}
          {esperaTotal > 0 && (
            <tr>
              <th scope="row" className="text-start">
                ESPERA
              </th>
              <td>{esperaSeleccionados ? edificiosSeleccionadosEspera : "-"}</td>
              <td>{esperaSeleccionados ? esperaSeleccionados : "-"}</td>
              <td>
                {esperaSeleccionados
                  ? audienciaSeleccionadaEspera.toLocaleString(localString(pais), {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    })
                  : "-"}
              </td>
              <td>
                {esperaSeleccionados && horasFinal
                  ? horasFinal.toLocaleString(localString(pais), {
                      minimumFractionDigits: 1,
                      maximumFractionDigits: 1,
                    })
                  : "-"}
              </td>
              <td>{esperaSeleccionados && plazo ? plazo : "-"}</td>
              <td>
                {salidasEspera
                  ? salidasEspera.toLocaleString(localString(pais), {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    })
                  : "-"}
              </td>
              <td>
                {impactosTotalEspera
                  ? impactosTotalEspera.toLocaleString(localString(pais), {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    })
                  : "-"}
              </td>
              <td>{esperaSeleccionados && duracion ? duracion : "-"}</td>
              <td className="text-center">
                {tarifaFriaEspera
                  ? `${selectedMoneda} ${tarifaFriaEspera.toLocaleString(localString(pais), {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    })}`
                  : "-"}
              </td>
              <td className="text-center">
                {inversionEsperaFinal
                  ? descuentoGlobal && todosLosTotalesCompletos()
                    ? `${(descuentoGlobal * 100).toLocaleString(localString(pais), {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                      })}%`
                    : "-"
                  : "-"}
              </td>
              <td className="text-center">
                {inversionEsperaFinal
                  ? `${selectedMoneda} ${inversionEsperaFinal.toLocaleString(localString(pais), {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    })}`
                  : "-"}
              </td>
              <td className="text-center">
                {cpmEsperaFinal
                  ? `${selectedMoneda} ${cpmEsperaFinal.toLocaleString(localString(pais), {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    })}`
                  : "-"}
              </td>
            </tr>
          )}
          {coworkTotal > 0 && (
            <tr>
              <th scope="row" className="text-start">
                COWORK
              </th>
              <td>{coworkSeleccionados ? edificiosSeleccionadosCowork : "-"}</td>
              <td>{coworkSeleccionados ? coworkSeleccionados : "-"}</td>
              <td>
                {coworkSeleccionados
                  ? audienciaSeleccionadaCowork.toLocaleString(localString(pais), {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    })
                  : "-"}
              </td>
              <td>
                {coworkSeleccionados && horasFinal
                  ? horasFinal.toLocaleString(localString(pais), {
                      minimumFractionDigits: 1,
                      maximumFractionDigits: 1,
                    })
                  : "-"}
              </td>
              <td>{coworkSeleccionados && plazo ? plazo : "-"}</td>
              <td>
                {salidasCowork
                  ? salidasCowork.toLocaleString(localString(pais), {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    })
                  : "-"}
              </td>
              <td>
                {impactosTotalCowork
                  ? impactosTotalCowork.toLocaleString(localString(pais), {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    })
                  : "-"}
              </td>
              <td>{coworkSeleccionados && duracion ? duracion : "-"}</td>
              <td className="text-center">
                {tarifaFriaCowork
                  ? `${selectedMoneda} ${tarifaFriaCowork.toLocaleString(localString(pais), {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    })}`
                  : "-"}
              </td>
              <td className="text-center">
                {inversionCoworkFinal
                  ? descuentoGlobal && todosLosTotalesCompletos()
                    ? `${(descuentoGlobal * 100).toLocaleString(localString(pais), {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                      })}%`
                    : "-"
                  : "-"}
              </td>
              <td className="text-center">
                {inversionCoworkFinal
                  ? `${selectedMoneda} ${inversionCoworkFinal.toLocaleString(localString(pais), {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    })}`
                  : "-"}
              </td>
              <td className="text-center">
                {cpmCoworkFinal
                  ? `${selectedMoneda} ${cpmCoworkFinal.toLocaleString(localString(pais), {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    })}`
                  : "-"}
              </td>
            </tr>
          )}
          <tr className="total-row">
            <th scope="row" className="text-start">
              TOTAL
            </th>
            <td>
              {edificiosUnicosTotal
                ? edificiosUnicosTotal.toLocaleString(localString(pais), {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  })
                : "-"}
            </td>
            <td>
              {(ascensoresSeleccionados || totemsSeleccionados || coworkSeleccionados || esperaSeleccionados) > 0
                ? (ascensoresSeleccionados || 0) +
                  (totemsSeleccionados || 0) +
                  (coworkSeleccionados || 0) +
                  (esperaSeleccionados || 0)
                : "-"}
            </td>
            <td>
              {audienciaSeleccionadaTotal
                ? audienciaSeleccionadaTotal.toLocaleString(localString(pais), {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  })
                : "-"}
            </td>
            <td>
              {edificiosUnicosTotal && horasFinal
                ? horasFinal.toLocaleString(localString(pais), { minimumFractionDigits: 1, maximumFractionDigits: 1 })
                : "-"}
            </td>
            <td>{edificiosUnicosTotal && plazo ? plazo : "-"}</td>
            <td>
              {edificiosUnicosTotal && salidasTotales
                ? salidasTotales.toLocaleString(localString(pais), {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  })
                : "-"}
            </td>
            <td>
              {impactosTotales
                ? impactosTotales.toLocaleString(localString(pais), {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  })
                : "-"}
            </td>
            <td>{duracion ? duracion : "-"}</td>
            <td className="text-center">
              {tarifaFriaTotal
                ? `${selectedMoneda} ${tarifaFriaTotal.toLocaleString(localString(pais), {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  })}`
                : "-"}
            </td>
            <td className="text-center">
              {descuentoGlobal && todosLosTotalesCompletos()
                ? manualDiscountPercentage > 0
                  ? `${(descuentoGlobal * 100).toLocaleString(localString(pais), {
                      minimumFractionDigits: 1,
                      maximumFractionDigits: 1,
                    })}% + ${manualDiscountPercentage.toLocaleString(localString(pais), {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    })}%`
                  : `${(descuentoGlobal * 100).toLocaleString(localString(pais), {
                      minimumFractionDigits: 1,
                      maximumFractionDigits: 1,
                    })}%`
                : "-"}
            </td>
            <td className="text-center">
              {inversionFinalTotal
                ? `${selectedMoneda} ${(manualDiscountAmount > 0 ? finalAmount : inversionFinalTotal).toLocaleString(
                    localString(pais),
                    {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    }
                  )}`
                : "-"}
            </td>
            <td className="text-center">
              {cpmTotalFinal && todosLosTotalesCompletos()
                ? `${selectedMoneda} ${cpmTotalFinal.toLocaleString(localString(pais), {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  })}`
                : "-"}
            </td>
          </tr>
        </tbody>
      </table>
      <div className="mt-3 mb-3 d-flex gap-2 justify-content-center">
        {["superadmin", "gerencia", "comercial"].includes(rol) && (
          <Button
            className="action-button"
            color="danger"
            onClick={() => setShowDiscountModal(true)}
            disabled={!todosLosTotalesCompletos()}
          >
            Descuento Manual
          </Button>
        )}
        {isEditMode ? (
          <Button
            className="btn-actualizar"
            color={hasChanges && !loading ? "success" : "secondary"}
            onClick={handleSubmitUpdate(handleUpdateOportunidad)}
            disabled={!hasChanges || loading}
          >
            {loading ? "Editando..." : "Editar Oportunidad"}
          </Button>
        ) : (
          <>
            <Button
              className="action-button"
              color="success"
              onClick={() => setShowLinkModal(true)}
              disabled={!todosLosTotalesCompletos()}
            >
              Vincular Cliente
            </Button>
            <PDFDownloadLink document={pdfDocument} fileName={generateFileName()}>
              <Button className="action-button" color="primary" disabled={!todosLosTotalesCompletos()}>
                Generar PDF
              </Button>
            </PDFDownloadLink>
          </>
        )}
      </div>
      <Modal isOpen={showLinkModal} toggle={() => setShowLinkModal(false)}>
        <ModalHeader toggle={() => setShowLinkModal(false)}>Vincular oportunidad</ModalHeader>
        {clientesLoading ? (
          <ModalBody>
            <div>Cargando clientes...</div>
          </ModalBody>
        ) : (
          <form
            onSubmit={handleSubmitLink(
              async (data) => {
                try {
                  await handleLinkOportunidad(data);
                } catch (error) {
                  console.error("Error al procesar handleLinkOportunidad desde el formulario:", error);
                  toast.error("Error al vincular la oportunidad. Por favor, intenta de nuevo.");
                }
              },
              (errors) => {
                console.log("Errores de validación en el formulario:", errors);
              }
            )}
          >
            <ModalBody>
              <div className="mb-3">
                <label htmlFor="clientePublicitario" className="form-label">
                  Cliente Publicitario
                </label>
                <select
                  className={`form-select ${linkErrors.clientePublicitario ? "is-invalid" : ""}`}
                  {...registerLink("clientePublicitario", { required: "Debes seleccionar un cliente publicitario" })}
                >
                  <option value="">Selecciona un cliente</option>
                  {renderClientesOptions()}
                </select>
                {linkErrors.clientePublicitario && (
                  <div className="invalid-feedback">{linkErrors.clientePublicitario.message}</div>
                )}
              </div>
              <div className="mb-3">
                <label className="form-label">¿A quién va dirigida?</label>
                <div className="d-flex gap-2">
                  <FormGroup check>
                    <Input
                      type="radio"
                      name="tipoCotizacion"
                      value="cliente"
                      checked={tipoCotizacion === "cliente"}
                      {...registerLink("tipoCotizacion", { required: "Debes seleccionar una opción" })}
                      onChange={(e) => {
                        setTipoCotizacion(e.target.value);
                        setLinkValue("tipoCotizacion", e.target.value);
                      }}
                    />
                    <Label check>Cliente Directo</Label>
                  </FormGroup>
                  <FormGroup check>
                    <Input
                      type="radio"
                      name="tipoCotizacion"
                      value="agencia"
                      checked={tipoCotizacion === "agencia"}
                      {...registerLink("tipoCotizacion", { required: "Debes seleccionar una opción" })}
                      onChange={(e) => {
                        setTipoCotizacion(e.target.value);
                        setLinkValue("tipoCotizacion", e.target.value);
                      }}
                    />
                    <Label check>Agencia</Label>
                  </FormGroup>
                </div>
                {linkErrors.tipoCotizacion && (
                  <div className="invalid-feedback d-block">{linkErrors.tipoCotizacion.message}</div>
                )}
              </div>
              <div className="mb-3">
                <label htmlFor="campana" className="form-label">
                  Campaña asociada (opcional)
                </label>
                <input
                  type="text"
                  className={`form-control ${linkErrors.campana ? "is-invalid" : ""}`}
                  maxLength={15}
                  {...registerLink("campana", {
                    onChange: (e) => {
                      e.target.value = e.target.value.toUpperCase().trimEnd();
                    },
                    maxLength: {
                      value: 15,
                      message: "La 'campaña' no puede exceder los 15 caracteres",
                    },
                    validate: (value) => value.trimEnd() === value || "No se permiten espacios al final",
                  })}
                />
                {linkErrors.campana && <div className="invalid-feedback">{linkErrors.campana.message}</div>}
              </div>
              <div className="mb-3">
                <label htmlFor="canal" className="form-label">
                  Canal
                </label>
                <select
                  className={`form-select ${linkErrors.canal ? "is-invalid" : ""}`}
                  {...registerLink("canal", { required: "Debes seleccionar un canal" })}
                >
                  <option value="">Selecciona un canal...</option>
                  <option value="B2C">B2C</option>
                  <option value="B2B">B2B</option>
                  <option value="B2G">B2G</option>
                </select>
                {linkErrors.canal && <div className="invalid-feedback">{linkErrors.canal.message}</div>}
              </div>
              <div className="mb-3">
                <label className="form-label">Cierre</label>
                <div className="d-flex gap-3">
                  <div className="flex-fill">
                    <label htmlFor="mes_cierre" className="form-label">
                      Mes Cierre
                    </label>
                    <select
                      className={`form-select uniform-select ${linkErrors.mes_cierre ? "is-invalid" : ""}`}
                      {...registerLink("mes_cierre", {
                        required: "Debes seleccionar un mes de cierre",
                        validate: (value, formValues) => {
                          if (!value || !formValues.mes_factura) return true;
                          const cierreFull = `${formValues.ano_cierre}-${value.padStart(2, "0")}`;
                          const facturaFull = `${formValues.ano_factura}-${formValues.mes_factura.padStart(2, "0")}`;
                          return (
                            new Date(cierreFull) <= new Date(facturaFull) ||
                            "Fecha de cierre no puede ser posterior a fecha de factura"
                          );
                        },
                      })}
                    >
                      <option value="">Selecciona un mes...</option>
                      {orderedMeses.map((mes) => (
                        <option key={mes.value} value={mes.value}>
                          {mes.label}
                        </option>
                      ))}
                    </select>
                    {linkErrors.mes_cierre && <div className="invalid-feedback">{linkErrors.mes_cierre.message}</div>}
                  </div>
                  <div className="flex-fill">
                    <label htmlFor="ano_cierre" className="form-label">
                      Año Cierre
                    </label>
                    <select
                      className={`form-select uniform-select ${linkErrors.ano_cierre ? "is-invalid" : ""}`}
                      {...registerLink("ano_cierre", { required: "Debes seleccionar un año de cierre" })}
                    >
                      <option value="2025">2025</option>
                      <option value="2026">2026</option>
                      <option value="2027">2027</option>
                    </select>
                    {linkErrors.ano_cierre && <div className="invalid-feedback">{linkErrors.ano_cierre.message}</div>}
                  </div>
                </div>
              </div>
              <div className="mb-3">
                <label className="form-label">Facturación</label>
                <div className="d-flex gap-3">
                  <div className="flex-fill">
                    <label htmlFor="mes_factura" className="form-label">
                      Mes Factura
                    </label>
                    <select
                      className={`form-select uniform-select ${linkErrors.mes_factura ? "is-invalid" : ""}`}
                      {...registerLink("mes_factura", {
                        required: "Debes seleccionar un mes de factura",
                        validate: (value, formValues) => {
                          if (!value || !formValues.mes_cierre) return true;
                          const cierreFull = `${formValues.ano_cierre}-${formValues.mes_cierre.padStart(2, "0")}`;
                          const facturaFull = `${formValues.ano_factura}-${value.padStart(2, "0")}`;
                          return (
                            new Date(cierreFull) <= new Date(facturaFull) ||
                            "Fecha de factura no puede ser anterior a fecha de cierre"
                          );
                        },
                      })}
                    >
                      <option value="">Selecciona un mes...</option>
                      {orderedMeses.map((mes) => (
                        <option key={mes.value} value={mes.value}>
                          {mes.label}
                        </option>
                      ))}
                    </select>
                    {linkErrors.mes_factura && <div className="invalid-feedback">{linkErrors.mes_factura.message}</div>}
                  </div>
                  <div className="flex-fill">
                    <label htmlFor="ano_factura" className="form-label">
                      Año Factura
                    </label>
                    <select
                      className={`form-select uniform-select ${linkErrors.ano_factura ? "is-invalid" : ""}`}
                      {...registerLink("ano_factura", { required: "Debes seleccionar un año de factura" })}
                    >
                      <option value="2025">2025</option>
                      <option value="2026">2026</option>
                      <option value="2027">2027</option>
                    </select>
                    {linkErrors.ano_factura && <div className="invalid-feedback">{linkErrors.ano_factura.message}</div>}
                  </div>
                </div>
              </div>
              <div className="mb-3">
                <label htmlFor="estatus" className="form-label">
                  Estatus
                </label>
                <select
                  className={`form-select ${linkErrors.estatus ? "is-invalid" : ""}`}
                  {...registerLink("estatus", { required: "Debes seleccionar un estatus" })}
                >
                  <option value="">Selecciona un estatus...</option>
                  <option value="100%">100%</option>
                  <option value="90%">90%</option>
                  <option value="75%">75%</option>
                  <option value="50%">50%</option>
                </select>
                {linkErrors.estatus && <div className="invalid-feedback">{linkErrors.estatus.message}</div>}
              </div>
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={() => setShowLinkModal(false)} disabled={isSubmitting}>
                Cancelar
              </Button>
              <Button color="primary" type="submit" disabled={!canLinkOpportunity || isSubmitting}>
                {isSubmitting ? "Procesando..." : "Vincular"}
              </Button>
            </ModalFooter>
          </form>
        )}
      </Modal>
      <Modal isOpen={showDiscountModal} toggle={() => setShowDiscountModal(false)} className="custom-modal">
        <ModalHeader toggle={() => setShowDiscountModal(false)}>Aplicar Descuento Manual</ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label className="mb-2">¿Qué descuento deseas realizar?</Label>
            <div className="d-flex flex-column gap-2">
              <FormGroup check>
                <Input
                  type="radio"
                  name="discountMethod"
                  value="finalAmount"
                  checked={discountMethod === "finalAmount"}
                  onChange={() => {
                    setDiscountMethod("finalAmount");
                    setFinalAmountStr("");
                    setFinalAmount(0);
                  }}
                />
                <Label check>Definir un monto objetivo</Label>
              </FormGroup>
              <FormGroup check>
                <Input
                  type="radio"
                  name="discountMethod"
                  value="discountAmount"
                  checked={discountMethod === "discountAmount"}
                  onChange={() => {
                    setDiscountMethod("discountAmount");
                    setManualDiscountAmountStr("");
                    setManualDiscountAmount(0);
                  }}
                />
                <Label check>Descontar un monto</Label>
              </FormGroup>
              <FormGroup check>
                <Input
                  type="radio"
                  name="discountMethod"
                  value="percentage"
                  checked={discountMethod === "percentage"}
                  onChange={() => {
                    setDiscountMethod("percentage");
                    setDiscountPercentageStr("");
                    setDiscountPercentage(0);
                  }}
                />
                <Label check>Descontar un porcentaje</Label>
              </FormGroup>
            </div>
          </FormGroup>
          <FormGroup>
            <Label>
              {discountMethod === "finalAmount"
                ? "Ingresa el Monto Final Deseado"
                : discountMethod === "discountAmount"
                  ? "Ingresa el Monto de Descuento"
                  : "Ingresa el Porcentaje de Descuento"}
            </Label>
            <div style={{ position: "relative", display: "inline-block", width: "100%" }}>
              <Input
                type="text"
                value={
                  discountMethod === "finalAmount"
                    ? finalAmountStr
                    : discountMethod === "discountAmount"
                      ? manualDiscountAmountStr
                      : discountPercentageStr
                }
                onChange={(e) => {
                  let value = e.target.value.replace(/,/g, "."); // Normalizar comma a punto
                  value = value.replace(/[^\d.]/g, ""); // Solo dígitos y punto
                  const parts = value.split(".");
                  if (parts.length > 2) value = `${parts[0]}.${parts.slice(1).join("")}`; // Un solo punto
                  if (discountMethod === "percentage") {
                    const numValue = parseFloat(value);
                    if (numValue > 100) value = "100";
                    if (parts[1]?.length > 2) value = `${parts[0]}.${parts[1].slice(0, 2)}`; // Max 2 decimales
                  } else {
                    if (parts[1]?.length > 0) value = parts[0]; // Solo enteros para montos
                  }

                  if (discountMethod === "finalAmount") setFinalAmountStr(value);
                  else if (discountMethod === "discountAmount") setManualDiscountAmountStr(value);
                  else setDiscountPercentageStr(value);
                }}
                onBlur={(e) => {
                  let value = e.target.value.replace(/\.$/, ""); // Limpiar punto al final
                  if (discountMethod === "percentage") {
                    const numValue = parseFloat(value) || 0;
                    value = numValue.toFixed(2); // 2 decimales para porcentaje
                  } else {
                    value = parseInt(value, 10) || ""; // Enteros para montos
                  }
                  if (discountMethod === "finalAmount") setFinalAmountStr(value);
                  else if (discountMethod === "discountAmount") setManualDiscountAmountStr(value);
                  else setDiscountPercentageStr(value);
                }}
                onFocus={(e) => e.target.select()}
                placeholder={discountMethod === "percentage" ? "Ejemplo: 10.5 (máx 100)" : "Ejemplo: 3500000"}
                style={{ paddingRight: discountMethod === "percentage" ? "30px" : "8px" }}
                className="custom-input"
                invalid={discountMethod === "percentage" && parseFloat(discountPercentageStr) > 100}
              />
              {discountMethod === "percentage" && (
                <span
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    color: "#999",
                    fontSize: "1rem",
                    pointerEvents: "none",
                  }}
                >
                  %
                </span>
              )}
              {discountMethod === "percentage" && parseFloat(discountPercentageStr) > 100 && (
                <div className="invalid-feedback">El porcentaje no puede exceder 100.</div>
              )}
            </div>
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setShowDiscountModal(false)}>
            Cancelar
          </Button>
          <Button
            color="primary"
            onClick={() => {
              let newFinalAmount = 0;
              let newDiscountAmount = 0;
              let newPercentage = 0;
              let newDiscountType = discountMethod; // 'finalAmount' -> 'final', etc.
              if (discountMethod === "finalAmount") {
                newFinalAmount = parseInt(finalAmountStr, 10) || 0;
                newDiscountAmount = inversionFinalTotal - newFinalAmount;
                newPercentage = inversionFinalTotal > 0 ? (newDiscountAmount / inversionFinalTotal) * 100 : 0;
                newDiscountType = "final";
              } else if (discountMethod === "discountAmount") {
                newDiscountAmount = parseInt(manualDiscountAmountStr, 10) || 0;
                newFinalAmount = inversionFinalTotal - newDiscountAmount;
                newPercentage = inversionFinalTotal > 0 ? (newDiscountAmount / inversionFinalTotal) * 100 : 0;
                newDiscountType = "amount";
              } else if (discountMethod === "percentage") {
                newPercentage = parseFloat(discountPercentageStr) || 0;
                if (rol === "comercial") newPercentage = Math.min(newPercentage, 10);
                else if (!["superadmin", "gerencia"].includes(rol)) newPercentage = 0;
                newDiscountAmount = (newPercentage / 100) * inversionFinalTotal;
                newFinalAmount = inversionFinalTotal - newDiscountAmount;
                newDiscountType = "percentage";
              }
              newFinalAmount = Math.floor(newFinalAmount);
              newDiscountAmount = Math.floor(newDiscountAmount);
              newPercentage = parseFloat(newPercentage.toFixed(2));
              const error = validateDiscount(inversionFinalTotal, newDiscountAmount, newFinalAmount, rol);
              if (error) {
                toast.error(error);
                return;
              }
              setDiscountType(newDiscountType);
              setFinalAmount(newFinalAmount);
              setManualDiscountAmount(newDiscountAmount);
              setDiscountPercentage(newPercentage);
              setOriginalAmount(inversionFinalTotal);
              setFinalAmountStr(newFinalAmount.toString());
              setManualDiscountAmountStr(newDiscountAmount.toString());
              setDiscountPercentageStr(newPercentage.toString());
              setShowDiscountModal(false);
              setForceRecalc((prev) => prev + 1);
              // Nuevo: Toast informativo básico (sin .info)
              toast("Descuento aplicado localmente. Guarda los cambios con 'Editar Oportunidad'.", {
                icon: "ℹ️", // Ícono de info para diferenciarlo visualmente
                duration: 5000, // Opcional: durar más para que el usuario lo lea
              });
            }}
          >
            Confirmar
          </Button>
          {isEditMode && manualDiscountAmount > 0 && (
            <Button
              color="danger"
              onClick={() => {
                setDiscountType("none");
                setManualDiscountAmount(0);
                setFinalAmount(inversionFinalTotal);
                setDiscountPercentage(0);
                setOriginalAmount(inversionFinalTotal);
                setManualDiscountAmountStr("");
                setFinalAmountStr(inversionFinalTotal.toString());
                setDiscountPercentageStr("0");
                setShowDiscountModal(false);
                setForceRecalc((prev) => prev + 1);
                toast.success("Descuento eliminado");
              }}
            >
              Eliminar Descuento
            </Button>
          )}
        </ModalFooter>
      </Modal>
    </div>
  );
};
